/* eslint-disable @typescript-eslint/no-unused-vars */
/* prettier-ignore */
export const endpoint = {
  tracking:                                 (data = {}) => `api/track`, // POST

  auth: {
    deploy_version:                         (data = {}) => `version`, // GET
    firebase_custom_token:                  (data = {}) => `api/firebase/token`, // GET
    firebase_register_device:               (data = {}) => `api/firebase/register-device`, // POST
    firebase_remove_device:                 (data = {}) => `api/firebase/remove-device`, // POST
    change_password:                        (data = {}) => `change-password`, // POST
  },

  rags:{
    resources:{
      datatable:                              (data = {}) => `api/other/rags`, // GET
      register_form:                          (data = {}) => `api/other/rags/form`, // GET
      register:                               (data = {}) => `api/other/rags`, // POST
      update_form:                            (data = {}) => `api/other/rags/${data.rag}/form`, // GET
      update:                                 (data = {}) => `api/other/rags/${data.rag}`, // PUT
      delete:                                 (data = {}) => `api/other/rags/${data.rag}`, // DELETE
    },
    fixed:{
      datatable:                              (data = {}) => `api/other/static-rags`, // GET
      update_form:                            (data = {}) => `api/other/static-rags/${data.rag}/form`, // GET
      update:                                 (data = {}) => `api/other/static-rags/${data.rag}`, // PUT
    }
  },

  token_usage:{
    page:                                     (data = {}) => `api/other/token-usage`, // GET
    summary:                                  (data = {}) => `api/other/token-usage/summary`, // GET
    datagrid:                                 (data = {}) => `api/other/token-usage/datagrid`, // GET
    farm:{
      page:                                   (data = {}) => `api/other/token-usage/farm/${data.farm}`, // GET
      limit_update_form:                      (data = {}) => `api/other/token-usage/farm/${data.farm}/form`, // GET
      limit_update:                           (data = {}) => `api/other/token-usage/farm/${data.farm}`, // PUT
    },
  },

  vic_ia:{
    chats:                                  (data = {}) => `vic/farm/${data.farm}/chats`, // GET
    stop:                                   (data = {}) => `vic/farm/${data.farm}/stop`, // PUT
    usage:                                  (data = {}) => `vic/farm/${data.farm}/usage`, // GET
    usage_users:                            (data = {}) => `vic/farm/${data.farm}/usage/users`, // GET
    chat:{
      confirmations:                        (data = {}) => `vic/farm/${data.farm}/chat/${data.chat}/confirmations/${data.tool_call_id}`, // POST, DELETE
      delete:                               (data = {}) => `vic/farm/${data.farm}/chat/${data.chat}`, // DELETE
      messages:                             (data = {}) => `vic/farm/${data.farm}/chat/${data.chat}/messages`, // GET
      message:                              (data = {}) => `vic/farm/${data.farm}/chat/${data.chat}/message`, // POST
      message_audio:                        (data = {}) => `vic/farm/${data.farm}/chat/${data.chat}/audio`, // POST
      create:                               (data = {}) => `vic/farm/${data.farm}/chat`, // POST
      create_audio:                         (data = {}) => `vic/farm/${data.farm}/chat/audio`, // POST
      rename:                               (data = {}) => `vic/farm/${data.farm}/chat/${data.chat}/rename`, // POST
      toggleFavorite:                       (data = {}) => `vic/farm/${data.farm}/chat/${data.chat}/toggle-favorite`, // POST
    },
  },

  cs:{
    bull_migration:{
      datatable:                            (data = {}) => `api/semen/need-migration/datatable`, // GET
    },
    integrations:{
      api:                                  (data = {}) => `api/integrations/api`, // GET
      cowsync:                              (data = {}) => `api/integrations/cowsync`, // GET
    },
    nps:{
      campaigns:{
        datatable:                          (data = {}) => `api/nps/campaigns/datatable`, // GET
        register_form:                      (data = {}) => `api/nps/campaigns/form`, // GET
        register:                           (data = {}) => `api/nps/campaigns`, // POST
        update:                             (data = {}) => `api/nps/campaigns/${data.campaign}`, // PUT
        update_form:                        (data = {}) => `api/nps/campaigns/${data.campaign}/form`, // GET
        delete:                             (data = {}) => `api/nps/campaigns/${data.campaign}`, // DELETE
      },
      farm: {
        answer: {
          datatable:                        (data = {}) => `api/nps/campaigns/${data.campaign}/farm-answers/datatable`, // GET
        },
        unanswered:{
          datatable:                        (data = {}) => `api/nps/campaigns/${data.campaign}/non-responding-farms/datatable`, // GET
        },
      },
      company: {
        answer: {
          datatable:                        (data = {}) => `api/nps/campaigns/${data.campaign}/company-answers/datatable`, // GET
        },
        unanswered:{
          datatable:                        (data = {}) => `api/nps/campaigns/${data.campaign}/non-responding-companies/datatable`, // GET
        },
      },
      answer: {
        delay:                              (data = {}) => `api/farm/${data.farm}/nps/campaign/answer/delay`, // GET
        register:                           (data = {}) => `api/farm/${data.farm}/nps/campaign/answer`, // POST
      },
    },
    customer_center: {
      datatable:                            (data = {}) => `/api/farm/customer-center/accounts`, // GET
      data_update:                          (data = {}) => `/api/farm/customer-center/data-update`, //GET
      interactions: {
        datatable:                          (data = {}) => `/api/farm/${data.farm}/customer-interaction/datatable`, // GET
        register_form:                      (data = {}) => `/api/farm/${data.farm}/customer-interaction/form`, // GET
        register:                           (data = {}) => `/api/farm/${data.farm}/customer-interaction`, // POST,
        update_form:                        (data = {}) => `/api/farm/${data.farm}/customer-interaction/${data.customer_interaction}/form`, // GET
        update:         	                  (data = {}) => `/api/farm/${data.farm}/customer-interaction/${data.customer_interaction}`, // PUT
        delete:                             (data = {}) => `/api/farm/${data.farm}/customer-interaction/${data.customer_interaction}` // DELETE
      },
      farm_profile:{
        self:                               (data = {}) => `api/farm/${data.farm}/profile`, // GET, POST, PUT,
        profile_form:                       (data = {}) => `api/farm/${data.farm}/profile/form`, // GET
      },
      engagement:                           (data = {}) => `api/farm/${data.farm}/customer-engagement/pages-access`, // GET
      accesses:                             (data = {}) => `api/farm/${data.farm}/access/datagrid`, // GET
    }
  },

  sentry: {
    backend_feedback:                       (data = {}) => `sentry`, // POST
  },

  websocket:{
    authorize:                              (data = {}) => `broadcasting/auth`, // POST
  },

  user: {
    info:                                   (data = {}) => `api/user-info`, // GET
    system_permissions:                     (data = {}) => `api/user/permission`, // GET
    farm_permissions:                       (data = {}) => `api/farm/${data.farm}/user/permission`, // GET
    company_permissions:                    (data = {}) => `api/company/${data.company}/user/permission`, // GET
    view_onboarding:                        (data = {}) => `api/user-info/onboarding`, // PATCH
    me: {
      form:                                 (data = {}) => `api/user/me/form`, // GET
      register:                             (data = {}) => `api/user/me`, // POST
      pwd_change_form:                      (data = {}) => `api/user/me/change-password-form`, // GET
    },
    notification: {
      form:                                 (data = {}) => `api/user/notification/form`, // GET
      register:                             (data = {}) => `api/user/notification/`, // PUT
    }
  },

  notifications:{
    system:                                 (data = {}) => `api/notification/system`, // GET
    farm:                                   (data = {}) => `api/notification/farm/${data.farm}`, // GET
    job:                                    (data = {}) => `api/farm/${data.farm}/job`, // GET
    alerts:                                 (data = {}) => `api/farm/${data.farm}/alert/datatable`, // GET
  },

  job: {
    self:                                   (data = {}) => `api/job/${data.job}`, // GET
    header:                                 (data = {}) => `api/job/${data.slug}/header`, // GET
    unrecognized_data:                      (data = {}) => `api/job/${data.slug}/unrecognized-data`, // GET
    file:                                   (data = {}) => `api/job/${data.job}/file`, // GET
    result:                                 (data = {}) => `api/job/${data.job}/result`, // GET
  },

  import:{
    files: {
      datagrid:                             (data = {}) => `api/farm/${data.farm}/cowsync/uploaded-files`, // GET
      file:                                 (data = {}) => `api/farm/${data.farm}/cowsync/uploaded-files/${data.file}`, // GET, DELETE
    },
    farm:{
      animal:{
        file:                               (data = {}) => `api/farm/${data.farm}/import-file/import-animals`, // GET
        self:                               (data = {}) => `api/farm/${data.farm}/import/animals`, // POST
      },
      discards:{
        file:                               (data = {}) => `api/farm/${data.farm}/import-file/import-discards`, // GET
        self:                               (data = {}) => `api/farm/${data.farm}/import/discards`, // POST
      },
      health:{
        file:                               (data = {}) => `api/farm/${data.farm}/import-file/import-health`, // GET
        self:                               (data = {}) => `api/farm/${data.farm}/import/diagnostics`, // POST
      },
      dry:{
        file:                               (data = {}) => `api/farm/${data.farm}/import-file/import-dry`, // GET
        self:                               (data = {}) => `api/farm/${data.farm}/import/dry`, // POST
      },
      milk_control_individualized:{
        file:                               (data = {}) => `api/farm/${data.farm}/import-file/import-milk-production-individualized`, // GET
        self:                               (data = {}) => `api/farm/${data.farm}/import/milk-production`, // POST
      },
      milk_control_total:{
        file:                               (data = {}) => `api/farm/${data.farm}/import-file/import-milk-production-total`, // GET
        self:                               (data = {}) => `api/farm/${data.farm}/import/milk-production/total`, // POST
      },
      prepartum:{
        file:                               (data = {}) => `api/farm/${data.farm}/import-file/import-prepartum`, // GET
        self:                               (data = {}) => `api/farm/${data.farm}/import/prepartum`, // POST
      },
      reproduction:{
        file:                               (data = {}) => `api/farm/${data.farm}/import-file/import-reproduction`, // GET
        self:                               (data = {}) => `api/farm/${data.farm}/import/reproductions`, // POST
      },
      calving:{
        file:                               (data = {}) => `api/farm/${data.farm}/import-file/import-calving`, // GET
        self:                               (data = {}) => `api/farm/${data.farm}/import/calving`, // POST
      },
      dairy_plan:{
        reproduction:                       (data = {}) => `api/farm/${data.farm}/import/reproduction/dairy-plan`, // POST
        discards:                           (data = {}) => `api/farm/${data.farm}/import/discards/dairy-plan`, // POST
      },
      dairy_comp: {
        self:                               (data = {}) => `api/farm/${data?.farm}/import/reproduction/dairycomp` // POST
      },
      abs_monitor:{
        reproduction:                       (data = {}) => `api/farm/${data.farm}/import/reproduction/abs-monitor`, // POST
      },
      delpro:{
        reproduction:                       (data = {}) => `api/farm/${data.farm}/import/reproduction/delpro`, // POST
        discards:                           (data = {}) => `api/farm/${data.farm}/import/discards/delpro` // POST
      },
      leigado: {
        reproduction:                       (data = {}) => `api/farm/${data.farm}/import/reproduction/leigado`, // POST
      },
      bovisync:{
        self:                               (data = {}) => `api/farm/${data.farm}/import/reproduction/bovisync`, // POST
        discards:                           (data = {}) => `api/farm/${data.farm}/import/discards/bovisync`, // POST
      },
      lely:{
        reproduction:                       (data = {}) => `api/farm/${data.farm}/import/reproduction/lely`, // POST
      },
      ideagri:{
        reproduction:                       (data = {}) => `api/farm/${data.farm}/import/reproduction/ideagri`, // POST
        milk_production:                    (data = {}) => `api/farm/${data.farm}/import/milk-production/ideagri`, // POST
      },
      uniform_agri: {
        reproduction:                       (data = {}) => `api/farm/${data.farm}/import/reproduction/uniform-agri`, // POST
        discards:                           (data = {}) => `api/farm/${data.farm}/import/discards/uniform-agri`, // POST
      },
      body_assessment:{
        file:                               (data = {}) => `api/farm/${data.farm}/import-file/import-weighing`, // GET
        self:                               (data = {}) => `api/farm/${data.farm}/import/weighing`, // POST
      },
      mating:{
        file:                               (data = {}) => `api/farm/${data.farm}/import-file/import-mating`, // GET
        self:                               (data = {}) => `api/farm/${data.farm}/import/mating`, // POST
      },
      animal_update:{
        file:                               (data = {}) => `api/farm/${data.farm}/import-file/update-animal-registration`, // GET
        self:                               (data = {}) => `api/farm/${data.farm}/import/update-animal-registration`, // POST
      },
      reproductive_event_history:{
        file:                               (data = {}) => `api/farm/${data.farm}/import-file/import-reproductive-history`, // GET
        self:                               (data = {}) => `api/farm/${data.farm}/import/reproduction/history`, // POST
      },
      protocols_animals:{
        file:                               (data = {}) => `api/farm/${data.farm}/import-file/import-protocol-animals`, // GET
        self:                               (data = {}) => `api/farm/${data.farm}/protocol-schedule/${data.protocolSlug}/animals/import` // POST
      }
    },
    system:{
      ccom:{
        file:                               (data = {}) => `api/import-file/import-ccom`, // GET
      },
      ctech: {
        file:                               (data = {}) => `api/import-file/import-collar`, // GET
        self:                               (data = {}) => `api/collar/import`, // POST
      },
      cenv: {
        file:                               (data = {}) => `api/import-file/import-cenv`, // GET
        self:                               (data = {}) => `api/cenv/import`, // POST
      },
      ctech_review:{
        file:                               (data = {}) => `api/import-file/review-collars`, // GET
        self:                               (data = {}) => `api/collar/review`, // POST
      },
      bull_semen:{
        file:                               (data = {}) => `api/import-file/import-semen`, // GET
        self:                               (data = {}) => `api/semen/import`, // POST
      },
      new_bull_semen:{
        file:                               (data = {}) => `api/import-file/import-new-semen`, // GET
        self:                               (data = {}) => `api/new-semen/import`, // POST
      },
    }
  },

  export:{
    farm:{
      general: {
        form:                               (data = {}) => `api/farm/${data.farm}/export/general-data/form`, // GET
        register:                           (data = {}) => `api/farm/${data.farm}/export/general-data`, // POST
      },
      holstein: {
        form:                               (data = {}) => `api/farm/${data.farm}/export/holstein-data/form`, // GET
        register:                           (data = {}) => `api/farm/${data.farm}/export/holstein-data`, // POST
      }
    }
  },

  farm: {
    self:                                   (data = {}) => `api/farm/${data.farm}`, // GET
    access_datatable:                       (data = {}) => `api/farm/access`, // GET
    search:                                 (data = {}) => `api/farm/search`, // GET
    global_search:                          (data = {}) => `api/farm/${data.farm}/search`, // GET
    favorite:                               (data = {}) => `api/farm/${data.farm}/favorite`, // DELETE, POST
    status:                                 (data = {}) => `api/farm/${data.farm}/status`, // GET
    register_form:                          (data = {}) => `api/farm/form`, // GET
    register:                               (data = {}) => `api/farm`, // POST
    update_form:                            (data = {}) => `api/farm/${data.farm}/form`, // GET
    update:                                 (data = {}) => `api/farm/${data.farm}`, // PUT
    remove:                                 (data = {}) => `api/farm/${data.farm}`, // DELETE
    dashboard:                              (data = {}) => `api/farm/${data.farm}/dashboard/new-dashboard`, // GET

    integrations:{
      settings:                             (data = {}) => `api/farm/${data.farm}/api-integrations/${data.integration}/settings`, // GET
      executions:                           (data = {}) => `api/farm/${data.farm}/api-integrations/${data.integration}/executions`, // GET
      self:                                 (data = {}) => `api/farm/${data.farm}/api-integrations/${data.integration}`, // GET
      connect:                              (data = {}) => `api/farm/${data.farm}/api-integrations/${data.integration}`, // POST
      connect_form:                         (data = {}) => `api/farm/${data.farm}/api-integrations/${data.integration}/form`, // GET
      disconnect:                           (data = {}) => `api/farm/${data.farm}/api-integrations/${data.integration}`, // DELETE
      list:                                 (data = {}) => `api/farm/${data.farm}/api-integrations`, // GET
      services:{
        datagrid:                           (data = {}) => `api/farm/${data.farm}/tokens/datatable`, // GET
        delete:                             (data = {}) => `oauth/tokens/${data.token}`, // DELETE
      },
      sync:                                 (data = {}) => `api/farm/${data.farm}/api-integrations/${data.integration}/run`, // POST
    },

    tokens:{
      simple_tokens:{
        datagrid:                           (data = {}) => `/api/farm/${data.farm}/tokenizable`, // GET
        register_form:                      (data = {}) => `/api/farm/${data.farm}/tokenizable/form`, // GET
        register:                           (data = {}) => `/api/farm/${data.farm}/tokenizable`, // POST
        remove:                             (data = {}) => `/api/farm/${data.farm}/tokenizable/${data.animal}`, // DELETE
      }
    },

    find_my_cow:{
      animal:                               (data = {}) => `api/farm/${data.farm}/find-my/animal/${data.animal}`, // GET
      collar:                               (data = {}) => `api/farm/${data.farm}/find-my/collar/${data.collar}`, // GET
    },


    gynecologic:{
      datatable:                            (data = {}) => `api/farm/${data.farm}/gynecologic-exam/datatable`, // GET
      apt:{
        form:                               (data = {}) => `api/farm/${data.farm}/event/reproduction/gynecologic-examp-apt/form`, // GET
        update_form:                        (data = {}) => `api/farm/${data.farm}/event/reproduction/gynecologic-examp-apt/${data.event}/form`, // PUT
      },
      inapt:{
        form:                               (data = {}) => `api/farm/${data.farm}/event/reproduction/gynecologic-examp-inapt/form`, // GET
        update_form:                        (data = {}) => `api/farm/${data.farm}/event/reproduction/gynecologic-examp-inapt/${data.event}/form`, // PUT
      }
    },

    contract:{
      renewals_datatable:                   (data = {}) => `api/farm/contract-event/renovations/datatable`, // GET
      datatable:                            (data = {}) => `api/farm/${data.farm}/contract-event/datatable`, // GET
      allowed_events:                       (data = {}) => `api/farm/${data.farm}/contract-event/next-events`, // GET
      renewal_cowconnect:{
        form:                               (data = {}) => `api/farm/${data.farm}/contract-event/renewal-cowconnect/form`, // GET
        register:                           (data = {}) => `api/farm/${data.farm}/contract-event/renewal-cowconnect`, // POST
        self_form:                          (data = {}) => `api/farm/${data.farm}/contract-event/renewal-cowconnect/${data.contract}/form`, // GET
        self:                               (data = {}) => `api/farm/${data.farm}/contract-event/renewal-cowconnect/${data.contract}`, // POST
      },
      renewal_monitoring:{
        form:                               (data = {}) => `api/farm/${data.farm}/contract-event/renewal-monitoring/form`, // GET
        register:                           (data = {}) => `api/farm/${data.farm}/contract-event/renewal-monitoring`, // POST
        self_form:                          (data = {}) => `api/farm/${data.farm}/contract-event/renewal-monitoring/${data.contract}/form`, // GET
        self:                               (data = {}) => `api/farm/${data.farm}/contract-event/renewal-monitoring/${data.contract}`, // POST
      },
      activation:{
        form:                               (data = {}) => `api/farm/${data.farm}/contract-event/monitoring-activation/form`, // GET
        register:                           (data = {}) => `api/farm/${data.farm}/contract-event/monitoring-activation`, // POST
        self_form:                          (data = {}) => `api/farm/${data.farm}/contract-event/monitoring-activation/${data.contract}/form`, // GET
        self:                               (data = {}) => `api/farm/${data.farm}/contract-event/monitoring-activation/${data.contract}`, // POST
      },
      cancellation:{
        form:                               (data = {}) => `api/farm/${data.farm}/contract-event/cancellation/form`, // GET
        register:                           (data = {}) => `api/farm/${data.farm}/contract-event/cancellation`, // POST
        self_form:                          (data = {}) => `api/farm/${data.farm}/contract-event/cancellation/${data.contract}/form`, // GET
        self:                               (data = {}) => `api/farm/${data.farm}/contract-event/cancellation/${data.contract}`, // POST
      },
      up_sell:{
        form:                               (data = {}) => `api/farm/${data.farm}/contract-event/up-sell/form`, // GET
        register:                           (data = {}) => `api/farm/${data.farm}/contract-event/up-sell`, // POST
        self_form:                          (data = {}) => `api/farm/${data.farm}/contract-event/up-sell/${data.contract}/form`, // GET
        self:                               (data = {}) => `api/farm/${data.farm}/contract-event/up-sell/${data.contract}`, // DELETE
      },
      down_sell:{
        form:                               (data = {}) => `api/farm/${data.farm}/contract-event/down-sell/form`, // GET
        register:                           (data = {}) => `api/farm/${data.farm}/contract-event/down-sell`, // POST
        self_form:                          (data = {}) => `api/farm/${data.farm}/contract-event/down-sell/${data.contract}/form`, // GET
        self:                               (data = {}) => `api/farm/${data.farm}/contract-event/down-sell/${data.contract}`, // POST
      },
      monitoring:{
        form:                               (data = {}) => `api/farm/${data.farm}/contract-event/initial-contract/form`, // GET
        register:                           (data = {}) => `api/farm/${data.farm}/contract-event/initial-contract`, // POST
        self_form:                          (data = {}) => `api/farm/${data.farm}/contract-event/initial-contract/${data.contract}/form`, // GET
        self:                               (data = {}) => `api/farm/${data.farm}/contract-event/initial-contract/${data.contract}`, // DELETE, POST
      },
      payment_start:{
        form:                               (data = {}) => `api/farm/${data.farm}/contract-event/payment-start/form`, // GET
        register:                           (data = {}) => `api/farm/${data.farm}/contract-event/payment-start`, // PUT
        self_form:                          (data = {}) => `api/farm/${data.farm}/contract-event/payment-start/${data.contract}/form`, // GET
        self:                               (data = {}) => `api/farm/${data.farm}/contract-event/payment-start/${data.contract}`, // DELETE, POST
      },
      reactivation_cowconnect:{
        form:                               (data = {}) => `api/farm/${data.farm}/contract-event/reactivation-cowconnect/form`, // GET
        register:                           (data = {}) => `api/farm/${data.farm}/contract-event/reactivation-cowconnect`, // POST
        self_form:                          (data = {}) => `api/farm/${data.farm}/contract-event/reactivation-cowconnect/${data.contract}/form`, // GET
        self:                               (data = {}) => `api/farm/${data.farm}/contract-event/reactivation-cowconnect/${data.contract}`, // POST
      },
      reactivation_monitoring:{
        form:                               (data = {}) => `api/farm/${data.farm}/contract-event/reactivation-monitoring/form`, // GET
        register:                           (data = {}) => `api/farm/${data.farm}/contract-event/reactivation-monitoring`, // POST
        self_form:                          (data = {}) => `api/farm/${data.farm}/contract-event/reactivation-monitoring/${data.contract}/form`, // GET
        self:                               (data = {}) => `api/farm/${data.farm}/contract-event/reactivation-monitoring/${data.contract}`, // POST
      },
      cross_sell_monitoring:{
        form:                               (data = {}) => `api/farm/${data.farm}/contract-event/cross-sell-monitoring/form`, // GET
        register:                           (data = {}) => `api/farm/${data.farm}/contract-event/cross-sell-monitoring`, // POST
        self_form:                          (data = {}) => `api/farm/${data.farm}/contract-event/cross-sell-monitoring/${data.contract}/form`, // GET
        self:                               (data = {}) => `api/farm/${data.farm}/contract-event/cross-sell-monitoring/${data.contract}`, // POST
      },
      cross_sell_cowconnect:{
        form:                               (data = {}) => `api/farm/${data.farm}/contract-event/cross-sell-cowconnect/form`, // GET
        register:                           (data = {}) => `api/farm/${data.farm}/contract-event/cross-sell-cowconnect`, // POST
        self_form:                          (data = {}) => `api/farm/${data.farm}/contract-event/cross-sell-cowconnect/${data.contract}/form`, // GET
        self:                               (data = {}) => `api/farm/${data.farm}/contract-event/cross-sell-cowconnect/${data.contract}`, // POST
      },
      suspension:{
        form:                               (data = {}) => `api/farm/${data.farm}/contract-event/temporary-suspension/form`, // GET
        register:                           (data = {}) => `api/farm/${data.farm}/contract-event/temporary-suspension`, // POST
        self_form:                          (data = {}) => `api/farm/${data.farm}/contract-event/temporary-suspension/${data.contract}/form`, // GET
        self:                               (data = {}) => `api/farm/${data.farm}/contract-event/temporary-suspension/${data.contract}`, // POST
      },
      reinstate:{
        form:                               (data = {}) => `api/farm/${data.farm}/contract-event/reinstate-contract/form`, // GET
        register:                           (data = {}) => `api/farm/${data.farm}/contract-event/reinstate-contract`, // POST
        self_form:                          (data = {}) => `api/farm/${data.farm}/contract-event/reinstate-contract/${data.contract}/form`, // GET
        self:                               (data = {}) => `api/farm/${data.farm}/contract-event/reinstate-contract/${data.contract}`, // POST
      },
      cancellation_request: {
        form:                               (data = {}) => `api/farm/${data.farm}/contract-event/cancellation-request/form`, // GET
        register:                           (data = {}) => `api/farm/${data.farm}/contract-event/cancellation-request`, // POST
        self_form:                          (data = {}) => `api/farm/${data.farm}/contract-event/cancellation-request/${data.contract}/form`, // GET
        self:   	                          (data = {}) => `api/farm/${data.farm}/contract-event/cancellation-request/${data.contract}`, // POST
      }
    },

    rates:{
      conception:                           (data = {}) => `api/farm/${data.farm}/pages/rate/conception`, // GET
      services:                             (data = {}) => `api/farm/${data.farm}/pages/rate/service`, // GET
      pregnancy:                            (data = {}) => `api/farm/${data.farm}/pages/rate/pregnancy`, // GET
      gestational:                          (data = {}) => `api/farm/${data.farm}/pages/rate/gestational-loss`, // GET
    },
    lists: {
      page:                                 (data = {}) => `/api/farm/${data.farm}/pages/resources/lists`, // GET
      custom:{
        datagrid:                           (data = {}) => `/api/farm/${data.farm}/custom-list/${data.listID}/datagrid`, // GET
        self:                               (data = {}) => `/api/farm/${data.farm}/custom-list/${data.listID}`, // GET
      },
      update_form:                          (data = {}) => `/api/farm/${data.farm}/custom-list/${data.listID}/form`, // GET
      health:{
        mastitis_history:                   (data = {}) => `/api/farm/${data.farm}/mastitis/history`, // GET
      }
    },
    cow_analytics:{
      wellness:{
        thermal_comfort_and_leisure:        (data = {}) => `api/farm/${data.farm}/pages/wellness/thermal-comfort-and-leisure`, // GET
        nutrition_and_consumption:          (data = {}) => `api/farm/${data.farm}/pages/wellness/nutrition-and-consumption`, // GET
      },
      health: {
        history:                            (data = {}) => `api/farm/${data.farm}/pages/health/history`, // GET
        occurrences:                        (data = {}) => `api/farm/${data.farm}/pages/health/occurrences`, // GET
        mastitis:                           (data = {}) => `api/farm/${data.farm}/pages/health/mastitis`, // GET
        mastitis_dynamics:                  (data = {}) => `api/farm/${data.farm}/pages/health/mastitis-dynamics`, // GET
        diagnosed_animals:                  (data = {}) => `api/farm/${data.farm}/datamart/health-new`, // GET
        alert_count:                        (data = {}) => `api/farm/${data.farm}/pages/health/alerts`, // GET
        hospital_time:                      (data = {}) => `api/farm/${data.farm}/pages/health/hospital-time`, // GET
      },
      heat_monitoring: {
        alert_utilization:                  (data = {}) => `api/farm/${data.farm}/pages/heat/alert-utilization`, // GET
        alert_hourly:                       (data = {}) => `api/farm/${data.farm}/pages/heat/alert-hourly`, // GET
        cycling_rate:                       (data = {}) => `api/farm/${data.farm}/pages/heat/cycling-rate`, // GET
        cycling_rate_accumulated:           (data = {}) => `api/farm/${data.farm}/pages/heat/cycling-rate-accumulated`, // GET
        heat_return:                        (data = {}) => `api/farm/${data.farm}/pages/heat/heat-return`, // GET
      },
      conception:{
        del_page:                           (data = {}) => `api/farm/${data.farm}/pages/conception/by-dim`, // GET
        days_open:                          (data = {}) => `api/farm/${data.farm}/pages/conception/days-open`, // GET
        per_type:                           (data = {}) => `api/farm/${data.farm}/pages/conception/by-type`, // GET
        per_services:                       (data = {}) => `api/farm/${data.farm}/pages/conception/by-service`, // GET
      },
      services:{
        performed:                          (data = {}) => `api/farm/${data.farm}/services/datatable`, // GET
        average_interval:                   (data = {}) => `api/farm/${data.farm}/pages/services/average-interval`, // GET
        monthly:                            (data = {}) => `api/farm/${data.farm}/pages/services/monthly`, // GET
        cycles:                             (data = {}) => `api/farm/${data.farm}/service-rates/datatable`, // GET
        dim_on_first_service:               (data = {}) => `api/farm/${data.farm}/pages/services/dim-on-first-service`, // GET
        dim_first_service_dispersion:       (data = {}) => `api/farm/${data.farm}/pages/services/dim-first-service-dispersion`, // GET
      },
      discard:{
        reason:                             (data = {}) => `api/farm/${data.farm}/pages/discards/reason`, // GET
        rate:                               (data = {}) => `api/farm/${data.farm}/pages/discards/rate`, // GET
        discarded_animal:                   (data = {}) => `api/farm/${data.farm}/animal/discard/datatable`, // GET
        departure_animal:                   (data = {}) => `api/farm/${data.farm}/animal/departure/datatable`, // GET
        moment:                             (data = {}) => `api/farm/${data.farm}/pages/discards/moment`, // GET
        monthly:                            (data = {}) => `api/farm/${data.farm}/pages/discards/monthly`, // GET
      },
      herd:{
        reproductive_distribution:          (data = {}) => `api/farm/${data.farm}/pages/herd/reproductive-distribution`, // GET
        avarege_dim_graph:                  (data = {}) => `api/farm/${data.farm}/pages/herd/average-dim`, // GET
        age_groups:                         (data = {}) => `api/farm/${data.farm}/pages/herd/age-group`, // GET
        lactating_projections:              (data = {}) => `api/farm/${data.farm}/pages/herd/lactating-projections`, // GET
        lactating_animals:                  (data = {}) => `api/farm/${data.farm}/pages/herd/lactating-animals`, // GET
        replacement:                        (data = {}) => `api/farm/${data.farm}/pages/herd/replacement-rate`, // GET
      },
      transition:{
        animal:                             (data = {}) => `api/farm/${data.farm}/event/datatable/reproduction/ppi`, // GET
        herd:                               (data = {}) => `api/farm/${data.farm}/pages/transition/average-ppi`, // GET
      },
      gestational:{
        bull_datatable:                     (data = {}) => `api/farm/${data.farm}/gestational-loss/by-semen/datatable`, // GET
        list_datatable:                     (data = {}) => `api/farm/${data.farm}/gestational-loss/list/datatable`, // GET
        loss_by_month:                      (data = {}) => `api/farm/${data.farm}/pages/gestational-loss/by-month`, // GET
        loss_by_stage:                      (data = {}) => `api/farm/${data.farm}/pages/gestational-loss/by-stage`, // GET
        loss_by_dim:                        (data = {}) => `api/farm/${data.farm}/pages/gestational-loss/by-dim`, // GET
      },
      rearing:{
        birth:                              (data = {}) => `api/farm/${data.farm}/pages/rearing/birth`, // GET
        growth_curve:                       (data = {}) => `api/farm/${data.farm}/pages/rearing/growth-curve`, // GET
        health:                             (data = {}) => `api/farm/${data.farm}/pages/rearing/health`, // GET
        daily_weight_gain:                  (data = {}) => `api/farm/${data.farm}/pages/rearing/daily-gain`, // GET
        mortality:                          (data = {}) => `api/farm/${data.farm}/pages/rearing/mortality`, // GET
        weight:                             (data = {}) => `api/farm/${data.farm}/pages/weaning/weight`, // GET
        open_apt_heifers:                   (data = {}) => `api/farm/${data.farm}/rearing/open-apt-heifers/datatable`, // GET
      },
      problem_cows: {
        critical_dim_without_pregnancy_datatable:     (data = {}) => `api/farm/${data.farm}/critical-dim-without-pregnancy/datatable`, // GET
      },
      marked_as: {
        all:                                (data = {}) => `api/farm/${data.farm}/animal/marked`, // GET
        unfit:                              (data = {}) => `api/farm/${data.farm}/animal/marked/unfit`, // GET
        induction:                          (data = {}) => `api/farm/${data.farm}/animal/marked/induction`, // GET
        discard:                            (data = {}) => `api/farm/${data.farm}/animal/marked/discard`, // GET
        protocol:                           (data = {}) => `api/farm/${data.farm}/animal/marked/protocol`, // GET
      }

    },

    management: {
      datatable:                            (data = {}) => `api/farm/datatable`, // GET
      network: {
        datatable:                          (data = {}) => `api/farm/${data.farm}/networks/datatable`, // GET
        register_form:                      (data = {}) => `api/farm/${data.farm}/networks/form`, // GET
        register:                           (data = {}) => `api/farm/${data.farm}/networks`, // POST
        update_form:                        (data = {}) => `api/farm/${data.farm}/networks/${data.network}/form`, // GET
        self:                               (data = {}) => `api/farm/${data.farm}/networks/${data.network}`, // PUT, DELETE
        set_main:                           (data = {}) => `api/farm/${data.farm}/networks/${data.network}/set-main`, // POST
      },
      extra_modules: {
        datatable:                          (data = {}) => `api/farm/${data.farm}/modules/form`, // GET
        update:                             (data = {}) => `api/farm/${data.farm}/modules/${data.module_slug}`, // PUT
      }
    },

    alert: {
      datatable:                            (data = {}) => `api/farm/${data.farm}/alert/datatable`, // GET
      view:                                 (data = {}) => `api/farm/${data.farm}/alert/${data.alert}/view`, // PUT
      view_many:                            (data = {}) => `api/farm/${data.farm}/alert/view-many`, // PUT
      view_all:                             (data = {}) => `api/farm/${data.farm}/alert/view-all`, // PUT
    },

    config: {
      handling: {
        form:                               (data = {}) => `api/farm/${data.farm}/config/handling/form`, // GET
        save:                               (data = {}) => `api/farm/${data.farm}/config`, // PUT
      },
      monitoring: {
        form:                               (data = {}) => `api/farm/${data.farm}/config/monitoring/form`, // GET
        save:                               (data = {}) => `api/farm/${data.farm}/config/monitoring`, // PUT
      },
      okr: {
        form:                               (data = {}) => `api/farm/${data.farm}/config/kpi/form`, // GET
        save:                               (data = {}) => `api/farm/${data.farm}/config`, // PUT
      },
      imports: {
        form:                               (data = {}) => `api/farm/${data.farm}/config/import/form`, // GET
        save:                               (data = {}) => `api/farm/${data.farm}/config/import`, // PUT
      }
    },

    vic: {
      form:                                 (data = {}) => `api/farm/${data.farm}/vic/form`, // GET
      save:                                 (data = {}) => `api/farm/${data.farm}/vic`, // PUT
      messages:                             (data = {}) => `api/farm/${data.farm}/vic/message`, // GET, PUT
      msg:                                  (data = {}) => `api/farm/${data.farm}/vic/message/${data.msg}`, // PUT, DELETE
      msg_read:                             (data = {}) => `api/farm/${data.farm}/vic/message/${data.msg}/read`, // PUT
    },

    batch: {
      variability:                          (data = {}) => `api/farm/${data.farm}/batch/${data.batch}/pages/monitoring-quartiles`, // GET
      datatable:                            (data = {}) => `api/farm/${data.farm}/batch/datatable`, // GET
      reorder:                              (data = {}) => `api/farm/${data.farm}/batch/${data.batch}/reorder`, // PUT
      revision:                             (data = {}) => `api/farm/${data.farm}/batch/${data.batch}/animal/datatable/revision`, // GET
      all:                                  (data = {}) => `api/farm/${data.farm}/batch`, // POST
      self:                                 (data = {}) => `api/farm/${data.farm}/batch/${data.batch}`, // PUT
      register_form:                        (data = {}) => `api/farm/${data.farm}/batch/form`, // GET
      update_form:                          (data = {}) => `api/farm/${data.farm}/batch/${data.batch}/form`, // GET
      camera:{
        datagrid:                           (data = {}) => `api/farm/${data.farm}/camera/datagrid`, // GET
        batch:                              (data = {}) => `api/farm/${data.farm}/camera/${data.batch}/page`, // GET
        photos:                             (data = {}) => `api/farm/${data.farm}/camera/${data.batch}/page/${encodeURIComponent(data.timestamp)}/photos`, // GET
      },
      pages:{
        monitoring:                         (data = {}) => `api/farm/${data.farm}/batch/${data.batch}/pages/monitoring`, // GET
        accumulated:                        (data = {}) => `api/farm/${data.farm}/batch/${data.batch}/pages/accumulated`, // GET
        profile:                            (data = {}) => `api/farm/${data.farm}/batch/${data.batch}/pages/intake-panting`, // GET
      },
      monitored:{
        datatable:                          (data = {}) => `api/farm/${data.farm}/batch/datatable/compiled`, // GET
      },
      diet: {
        datatable:                          (data = {}) => `api/farm/${data.farm}/batch/${data.batch}/diet/datatable`, // GET
        form:                               (data = {}) => `api/farm/${data.farm}/batch/${data.batch}/diet/form`, // GET
        update_form:                        (data = {}) => `api/farm/${data.farm}/batch/${data.batch}/diet/${data.diet}/form`, // GET
        register:                           (data = {}) => `api/farm/${data.farm}/batch/${data.batch}/diet`, // POST
        update:                             (data = {}) => `api/farm/${data.farm}/batch/${data.batch}/diet/${data.diet}`, // UPDATE
        remove:                             (data = {}) => `api/farm/${data.farm}/batch/${data.batch}/diet/${data.diet}`, // DELETE
      },
      thi:{
        hourly:                             (data = {}) => `api/farm/${data.farm}/point/${data.point}/pages/hourly`, // GET
        real_time:                          (data = {}) => `api/farm/${data.farm}/point/${data.point}/pages/real-time` // GET
      },
    },

    role: {
      self:                                 (data = {}) => `api/farm/${data.farm}/role/${data.role}`, // PUT, DELETE
      register:                             (data = {}) => `api/farm/${data.farm}/role`, // POST
      register_form:                        (data = {}) => `api/farm/${data.farm}/role/form`, // GET
      update_form:                          (data = {}) => `api/farm/${data.farm}/role/${data.role}/form`, // GET
      permissions:                          (data = {}) => `api/farm/${data.farm}/role/${data.role}/permission`, // GET, POST, DELETE
      duplicate:                            (data = {}) => `api/farm/${data.farm}/role/duplicate`, // POST
      datatable:                            (data = {}) => `api/farm/${data.farm}/role/datatable`, // GET
    },

    user: {
      self:                                 (data = {}) => `api/farm/${data.farm}/user/${data.user}`, // DELETE
      datatable:                            (data = {}) => `api/farm/${data.farm}/user/datatable`, // GET
      register:                             (data = {}) => `api/farm/${data.farm}/user`, // POST
      update:                               (data = {}) => `api/farm/${data.farm}/user/${data.user}`, // PUT
      register_form:                        (data = {}) => `api/farm/${data.farm}/user/form`, // GET
      update_form:                          (data = {}) => `api/farm/${data.farm}/user/${data.user}/form`, // GET
    },

    unit: {
      datatable:                            (data = {}) => `api/farm/${data.farm}/unit/datatable`, // GET
      self:                                 (data = {}) => `api/farm/${data.farm}/unit/${data.unit}`, // PUT, DELETE
      register:                             (data = {}) => `api/farm/${data.farm}/unit`, // POST
      register_form:                        (data = {}) => `api/farm/${data.farm}/unit/form`, // GET
      update_form:                          (data = {}) => `api/farm/${data.farm}/unit/${data.unit}/form`, // GET
    },

    job: {
      export_datatable:                     (data = {}) => `api/farm/${data.farm}/job/export/datatable`, // GET
      import_datatable:                     (data = {}) => `api/farm/${data.farm}/job/import/datatable`, // GET
      results:                              (data = {}) => `api/farm/${data.farm}/job/${data.slug}`, // GET
      unrecognized_data:                    (data = {}) => `api/farm/${data.farm}/job/${data.slug}/unrecognized-data`, // GET
      header:                               (data = {}) => `api/farm/${data.farm}/job/${data.slug}/header`, // GET
      file:                                 (data = {}) => `api/farm/${data.farm}/job/${data.job}/file`, // GET
      result:                               (data = {}) => `api/farm/${data.farm}/job/${data.job}/result`, // GET
    },

    animal: {
      attach_collar_form:                   (data = {}) => `api/farm/${data.farm}/animal/${data.animal}/collar/attach/form`, // GET
      register:                             (data = {}) => `api/farm/${data.farm}/animal`, // POST
      on_date:                              (data = {}) => `api/farm/${data.farm}/animal/on-date`, // GET
      form:                                 (data = {}) => `api/farm/${data.farm}/animal/form`, // GET
      accumulated_datatable:                (data = {}) => `api/farm/${data.farm}/animal/datatable/accumulated`, // GET
      management_datatable:                 (data = {}) => `api/farm/${data.farm}/animal/datatable`, // GET
      eligible_datatable:                   (data = {}) => `api/farm/${data.farm}/animal/datatable/apt`, // GET
      batch_divergence_datatable:           (data = {}) => `api/farm/${data.farm}/animal/datatable/batch-divergence`, // GET
      self:                                 (data = {}) => `api/farm/${data.farm}/animal/${data.animal}`, // GET
      remove:                               (data = {}) => `api/farm/${data.farm}/animal/${data.animal}`, // DELETE
      update:                               (data = {}) => `api/farm/${data.farm}/animal/${data.animal}`, // PUT
      status:                               (data = {}) => `api/farm/${data.farm}/animal/${data.animal}/new-status`, // GET
      move_form:                            (data = {}) => `api/farm/${data.farm}/animal/${data.animal}/move/form`, // GET
      move:                                 (data = {}) => `api/farm/${data.farm}/animal/${data.animal}/move`, // PUT
      update_form:                          (data = {}) => `api/farm/${data.farm}/animal/${data.animal}/form`, // GET
      inapt:                                (data = {}) => `api/farm/${data.farm}/animal/${data.animal}/inapt`, // DELETE, PUT, POST
      inapt_form:                           (data = {}) => `api/farm/${data.farm}/animal/${data.animal}/inapt/form`, // GET
      inapt_many_form:                      (data = {}) => `api/farm/${data.farm}/animal/marked/many/form`, // GET
      inapt_many:                           (data = {}) => `api/farm/${data.farm}/animal/marked/many`, // POST
      inapt_remove_form:                    (data = {}) => `api/farm/${data.farm}/animal/${data.animal}/inapt/remove/form`, // GET
      inapt_remove_many_form:               (data = {}) => `api/farm/${data.farm}/animal/marked/many/remove/form`, // GET
      inapt_remove_many:                    (data = {}) => `api/farm/${data.farm}/animal/marked/many/remove`, // PUT
      inapt_delete:                         (data = {}) => `api/farm/${data.farm}/animal/${data.animal}/inapt/delete`, // DELETE
      remove_form:                          (data = {}) => `api/farm/${data.farm}/animal/${data.animal}/delete/form`, // GET
      collar_history:                       (data = {}) => `api/farm/${data.farm}/animal/${data.animal}/collar/datatable`, // GET
      batch_history:                        (data = {}) => `api/farm/${data.farm}/animal/${data.animal}/batch-history/datatable`, // GET
      production_quality_datatable:         (data = {}) => `api/farm/${data.farm}/animal/${data.animal}/event/datatable/milking`, // GET
      reproduction_events_datatable:        (data = {}) => `api/farm/${data.farm}/animal/${data.animal}/event/datatable/reproduction`, // GET
      undo_discard_form:                    (data = {}) => `api/farm/${data.farm}/animal/${data.animal}/undo-discard/form`, // GET
      undo_discard:                         (data = {}) => `api/farm/${data.farm}/animal/${data.animal}/undo-discard`, // POST
      photo: {
        attach_form:                        (data = {}) => `api/farm/${data.farm}/animal/${data.animal}/photo/form`, // GET
        attach:                             (data = {}) => `api/farm/${data.farm}/animal/${data.animal}/photo`, // GET
        delete:                             (data = {}) => `api/farm/${data.farm}/animal/${data.animal}/photo`, // DELETE
      },
      pages:{
        daily:                              (data = {}) => `api/farm/${data.farm}/animal/${data.animal}/pages/daily-monitoring`, // GET
        hourly:                             (data = {}) => `api/farm/${data.farm}/animal/${data.animal}/pages/hourly-monitoring`, // GET
        heat_index:                         (data = {}) => `api/farm/${data.farm}/animal/${data.animal}/pages/heat-index`, // GET
        health_index:                       (data = {}) => `api/farm/${data.farm}/animal/${data.animal}/pages/health-index`, // GET
        breathing_index:                    (data = {}) => `api/farm/${data.farm}/animal/${data.animal}/pages/breathing-index`, // GET
        birth_index:                        (data = {}) => `api/farm/${data.farm}/animal/${data.animal}/pages/birth-index`, // GET
      },
      discard:{
        form:                               (data = {}) => `api/farm/${data.farm}/animal/remove/form`, // GET
        many_form:                          (data = {}) => `api/farm/${data.farm}/animal/many/remove/form`, // GET
        many:                               (data = {}) => `api/farm/${data.farm}/animal/many/remove`, // DELETE
      },
      birth:{
        register:                           (data = {}) => `api/farm/${data.farm}/animal/birth`, // POST
        form:                               (data = {}) => `api/farm/${data.farm}/animal/birth/form`, // GET
        update:                             (data = {}) => `api/farm/${data.farm}/animal/${data.animal}/event/birth/${data.event}`, // PUT
        update_form:                        (data = {}) => `api/farm/${data.farm}/animal/${data.animal}/event/birth/${data.event}/form`, // GET
      },
      health:{
        event_without_animal_form:          (data = {}) => `api/farm/${data.farm}/animal/health/form`, // GET
        event_register:                     (data = {}) => `api/farm/${data.farm}/animal/${data.animal}/event/health`, // POST
        event_form:                         (data = {}) => `api/farm/${data.farm}/animal/${data.animal}/event/health/form`, // GET
        event_update_form:                  (data = {}) => `api/farm/${data.farm}/animal/${data.animal}/event/health/${data.event}/form`, // GET
        event_update:                       (data = {}) => `api/farm/${data.farm}/animal/${data.animal}/event/health/${data.event}`, // PUT
        event_remove:                       (data = {}) => `api/farm/${data.farm}/animal/${data.animal}/event/health/${data.event}`, // DELETE
        ignore_event_temporarily:           (data = {}) => `api/farm/${data.farm}/animal/${data.animal}/event/health/ignore-temporarily`, // POST, DELETE
        normalize:                          (data = {}) => `api/farm/${data.farm}/animal/${data.animal}/event/health/normalize`, // POST
        group_events_datatable:             (data = {}) => `api/farm/${data.farm}/animal/${data.animal}/event/datatable/health/group`, // GET
        group_detail_datatable:             (data = {}) => `api/farm/${data.farm}/animal/${data.animal}/event/datatable/health/group/${data.group}`, // GET
      },
      cowbaby:{
        expired:                            (data = {}) => `api/farm/${data.farm}/animal/expired-cow-baby/datatable`, // GET
      },
      batch:{
        move_many:                          (data = {}) => `api/farm/${data.farm}/animal/move-many`, // PUT
        move_many_form:                     (data = {}) => `api/farm/${data.farm}/animal/move-many/form`, // GET
      },
      notes: {
        datatable:                          (data = {}) => `api/farm/${data.farm}/animal/${data.animal}/notes/datatable`, // GET
        register_form:                      (data = {}) => `api/farm/${data.farm}/animal/${data.animal}/notes/form`, // GET
        update_form:                        (data = {}) => `api/farm/${data.farm}/animal/${data.animal}/notes/${data.note}/form`, // GET
        register:                           (data = {}) => `api/farm/${data.farm}/animal/${data.animal}/notes`, // POST
        update:                             (data = {}) => `api/farm/${data.farm}/animal/${data.animal}/notes/${data.note}`, // PUT
        remove:                             (data = {}) => `api/farm/${data.farm}/animal/${data.animal}/notes/${data.note}`, // DELETE
        register_many_animals_form:         (data = {}) => `api/farm/${data.farm}/notes/form`, // GET
        register_many_animals:              (data = {}) => `api/farm/${data.farm}/notes`, // POST
      },
      event: {
        reproduction_event_many:            (data = {}) => `api/farm/${data.farm}/event/reproduction/many/simple`, // POST
        reproduction_event:                 (data = {}) => `api/farm/${data.farm}/animal/${data.animal}/event/reproduction`, // POST
        reproduction_event_self:            (data = {}) => `api/farm/${data.farm}/animal/${data.animal}/event/reproduction/${data.event}`, // PUT
      },
      body_assessment: {
        datatable:                          (data = {}) => `api/farm/${data.farm}/animal/${data.animal}/weights/datatable`, // GET
        register_form_animal:               (data = {}) => `api/farm/${data.farm}/animal/${data.animal}/weights/form`, // GET
        register_animal:                    (data = {}) => `api/farm/${data.farm}/animal/${data.animal}/weights`, // POST
        update_form:                        (data = {}) => `api/farm/${data.farm}/animal/${data.animal}/weights/${data.weight}/form`, // GET
        update:                             (data = {}) => `api/farm/${data.farm}/animal/${data.animal}/weights/${data.weight}`, // PUT
        delete:                             (data = {}) => `api/farm/${data.farm}/animal/${data.animal}/weights/${data.weight}`, // DELETE
        group_register_form:                (data = {}) => `api/farm/${data.farm}/weights/group/form`, // GET
        group_register:                     (data = {}) => `api/farm/${data.farm}/weights/group`, // POST
        history:                            (data = {}) => `api/farm/${data.farm}/weights/datagrid`, // GET
      },
    },

    milk_control: {
      collected_milk: {
        datatable:                          (data = {}) => `api/farm/${data.farm}/milk-collection/datatable`, // GET
        register:                           (data = {}) => `api/farm/${data.farm}/milk-collection`, // POST
        register_form:                      (data = {}) => `api/farm/${data.farm}/milk-collection/form`, // GET
        remove:                             (data = {}) => `api/farm/${data.farm}/milk-collection/${data.id}/delete`, // DELETE
        remove_form:                        (data = {}) => `api/farm/${data.farm}/milk-collection/${data.id}/delete/form`, // GET
        update:                             (data = {}) => `api/farm/${data.farm}/milk-collection/${data.id}`, // PUT
        update_form:                        (data = {}) => `api/farm/${data.farm}/milk-collection/${data.id}/form`, // GET
      },
      induction:{
        realized:                           (data = {}) => `api/farm/${data.farm}/induced-lactation/datatable`, // GET
      },
      production:{
        datatable:                          (data = {}) => `api/farm/${data.farm}/milk-production/datatable`, // GET
        self:                               (data = {}) => `api/farm/${data.farm}/milk-production/${data.date}`, // GET
        animal:                             (data = {}) => `api/farm/${data.farm}/milk-production/${data.date}/datatable`, // GET
        batch:                              (data = {}) => `api/farm/${data.farm}/milk-production/${data.date}/batch/datatable`, // GET
        forms:{
          production_register:              (data = {}) => `api/farm/${data.farm}/milk-production`, // POST
          production_delete:                (data = {}) => `api/farm/${data.farm}/milk-production/${data.date}`, // DELETE
          production_form:                  (data = {}) => `api/farm/${data.farm}/milk-production/form`,  // GET

          per_animal_form:                  (data = {}) => `api/farm/${data.farm}/milk-production/${data.date}/per-animal/form`, // GET
          per_animal_register:              (data = {}) => `api/farm/${data.farm}/milk-production/${data.date}/per-animal`, // POST
          per_animal_update:                (data = {}) => `api/farm/${data.farm}/milk-production/${data.date}/per-animal/${data.id}/form`, // GET
          per_animal_delete:                (data = {}) => `api/farm/${data.farm}/milk-production/${data.date}/per-animal/${data.id}`, // DELETE

          per_batch_form:                   (data = {}) => `api/farm/${data.farm}/milk-production/${data.date}/per-batch/form`, // GET
          per_batch_register:               (data = {}) => `api/farm/${data.farm}/milk-production/${data.date}/per-batch`, // POST
          per_batch_update:                 (data = {}) => `api/farm/${data.farm}/milk-production/${data.date}/per-batch/${data.id}/form`, // GET
          per_batch_delete:                 (data = {}) => `api/farm/${data.farm}/milk-production/${data.date}/per-batch/${data.id}`, // DELETE

          per_farm_form:                    (data = {}) => `api/farm/${data.farm}/milk-production/${data.date}/per-farm/form`, // GET
          per_farm_register:                (data = {}) => `api/farm/${data.farm}/milk-production/${data.date}/per-farm`, // POST
        },
      },
      ranking: {
        datatable:                          (data = {}) => `api/farm/${data.farm}/milk-production/productive-ranking`, // GET
      },
      general:                              (data = {}) => `api/farm/${data.farm}/pages/milk-production/general`, // GET
      tank_analysis:                        (data = {}) => `api/farm/${data.farm}/pages/milk-production/tank-analysis`, // GET
      quality: {
        register:                           (data = {}) => `api/farm/${data.farm}/milk-quality`, // POST
        register_form:                      (data = {}) => `api/farm/${data.farm}/milk-quality/form`, // GET
        datatable:                          (data = {}) => `api/farm/${data.farm}/milk-quality/datatable`, // GET
        update_form:                        (data = {}) => `api/farm/${data.farm}/milk-quality/${data.id}/form`, // GET
        update:                             (data = {}) => `api/farm/${data.farm}/milk-quality/${data.id}`, // PUT
        remove:                             (data = {}) => `api/farm/${data.farm}/milk-quality/${data.id}`, // DELETE
      },
    },

    nutrition: {
      diet: {
        drawer:                             (data = {}) => `api/farm/${data.farm}/diet/${data.slug}/pages/drawer`, // GET
        register:                           (data = {}) => `api/farm/${data.farm}/diet`, // POST
        register_form:                      (data = {}) => `api/farm/${data.farm}/diet/form`, // GET
        list_datatable:                     (data = {}) => `api/farm/${data.farm}/diet/datatable`, // GET
        update:                             (data = {}) => `api/farm/${data.farm}/diet/${data.diet}`, // PUT
        remove:                             (data = {}) => `api/farm/${data.farm}/diet/${data.diet}`, // DELETE
        update_form:                        (data = {}) => `api/farm/${data.farm}/diet/${data.diet}/form`, // GET
      },
      ingredient: {
        register:                           (data = {}) => `api/farm/${data.farm}/ingredient`, // POST
        register_form:                      (data = {}) => `api/farm/${data.farm}/ingredient/form`, // GET
        list_datatable:                     (data = {}) => `api/farm/${data.farm}/ingredient/datatable`, // GET
        update:                             (data = {}) => `api/farm/${data.farm}/ingredient/${data.ingredient}`, // PUT
        remove:                             (data = {}) => `api/farm/${data.farm}/ingredient/${data.ingredient}`, // DELETE
        update_form:                        (data = {}) => `api/farm/${data.farm}/ingredient/${data.ingredient}/form`, // GET
      }
    },

    reports: {
      collar:                               (data = {}) => `api/farm/${data.farm}/datamart/collar`, // GET
      collar_on_farm:                       (data = {}) => `api/farm/${data.farm}/datamart/collar-revision-local`, // GET
      health:                               (data = {}) => `api/farm/${data.farm}/datamart/health`, // GET
      collar_heat:                          (data = {}) => `api/farm/${data.farm}/datamart/collar-heat`, // GET
      unlinked_activity:                    (data = {}) => `api/farm/${data.farm}/collar/unlinked-activity/datatable`, // GET
      possible_removal:                     (data = {}) => `api/farm/${data.farm}/collar/possible-removal/datatable`, // GET
      open_animals:                         (data = {}) => `api/farm/${data.farm}/animal/datatable/empty`, // GET
      heat_return:                          (data = {}) => `api/farm/${data.farm}/insemination-return/datatable`, // GET
    },

    collar: {
      list_datatable:                       (data = {}) => `api/farm/${data.farm}/collar/datatable`, // GET
      change:                               (data = {}) => `api/farm/${data.farm}/collar/animal/change`, // PUT
      attach_form:                          (data = {}) => `api/farm/${data.farm}/collar/animal/attach/form`, // GET
      attach_with_collar_form:              (data = {}) => `api/farm/${data.farm}/collar/${data.collar}/animal/attach/form`, // GET
      attach:                               (data = {}) => `api/farm/${data.farm}/collar/animal/attach`, // PUT
      change_form:                          (data = {}) => `api/farm/${data.farm}/collar/animal/change/form`, // GET
      cowbaby_change_form:                  (data = {}) => `api/farm/${data.farm}/animal/${data.animal}/collar/change/form`, // GET
      cowbaby_change:                       (data = {}) => `api/farm/${data.farm}/animal/${data.animal}/collar/change`, // PUT
      self:                                 (data = {}) => `api/farm/${data.farm}/collar/${data.collar}`, // GET
      update_attach:                        (data = {}) => `api/farm/${data.farm}/collar/${data.collar}/animal`, // PUT
      update_attach_form:                   (data = {}) => `api/farm/${data.farm}/collar/${data.collar}/animal/form`, // GET
      detach:                               (data = {}) => `api/farm/${data.farm}/collar/${data.collar}/detach`, // PUT
      detach_form:                          (data = {}) => `api/farm/${data.farm}/collar/${data.collar}/detach/form`, // GET
      bulk_detach_form:                     (data = {}) => `api/farm/${data.farm}/collar/bulk-detach/form`, // GET
      bulk_detach:                          (data = {}) => `api/farm/${data.farm}/collar/bulk-detach`, // PUT, GET
      list_history_datatable:               (data = {}) => `api/farm/${data.farm}/collar/${data.collar}/animal/history/datatable`, // GET
      lost_collars:                         (data = {}) => `api/farm/${data.farm}/collar/lost/datatable`, // GET
      replace:                              (data = {}) => `api/farm/${data.farm}/collar/replace/datatable`, // GET
      inventory: {
        new_datatable:                      (data = {}) => `api/farm/${data.farm}/collar/new/datatable`, // GET
        summary_datatable:                  (data = {}) => `api/farm/${data.farm}/collar/summary/datatable`, // GET
        defective_datatable:                (data = {}) => `api/farm/${data.farm}/collar/defective/datatable`, // GET
      },
    },

    rearing:{
      weaning:                              (data = {}) => `api/farm/${data.farm}/animal/datatable/weaning`, // GET
    },

    health: {
      infirmary:{
        with_diagnostic:                    (data = {}) => `api/farm/${data.farm}/event/datatable/health/group/with-diagnostic`, // GET
        without_diagnostic:                 (data = {}) => `api/farm/${data.farm}/event/datatable/health/group/without-diagnostic`, // GET
        normalized:                         (data = {}) => `api/farm/${data.farm}/event/datatable/health/normalized`, // GET
      },
      baby_infirmary:{
        with_diagnostic:                    (data = {}) => `api/farm/${data.farm}/event/datatable/health/heifer/with-diagnostic`, // GET
        without_diagnostic:                 (data = {}) => `api/farm/${data.farm}/event/datatable/health/heifer/without-diagnostic`, // GET
        normalized:                         (data = {}) => `api/farm/${data.farm}/event/datatable/health/heifer/normalized`, // GET
      },
      challenge:                            (data = {}) => `api/farm/${data.farm}/event/datatable/health/challenge`, // GET
      protocols: {
        applications: {
          scheduled:                        (data = {}) => `/api/farm/${data?.farm}/sanitary-protocol/datatable/applications/scheduled`, // GET
          performed:                        (data = {}) => `/api/farm/${data?.farm}/sanitary-protocol/datatable/applications/realized`, // GET
        },
        models: {
          datatable:                        (data = {}) => `api/farm/${data.farm}/sanitary-protocol-model/datatable`, // GET
          register:                         (data = {}) => `api/farm/${data.farm}/sanitary-protocol-model`, // POST
          register_form:                    (data = {}) => `api/farm/${data.farm}/sanitary-protocol-model/form`, // GET
          update:                           (data = {}) => `api/farm/${data.farm}/sanitary-protocol-model/${data.protocol}`, // PUT,
          update_form:                      (data = {}) => `api/farm/${data.farm}/sanitary-protocol-model/${data.protocol}/form`, // GET,
          remove:                           (data = {}) => `api/farm/${data.farm}/sanitary-protocol-model/${data.protocol}`, // DELETE,
          duplicate_form:                   (data = {}) => `api/farm/${data.farm}/sanitary-protocol-model/${data.protocol}/duplicate/form`, // GET
          self:                             (data = {}) => `api/farm/${data.farm}/sanitary-protocol-model/${data.protocol}`, // GET
          info:                             (data = {}) => `api/farm/${data.farm}/sanitary-protocol-model/${data.protocol}/pages/drawer`, // GET
          details:{
            cases:                          (data = {}) => `api/farm/${data.farm}/sanitary-protocol-model/${data.protocol}/treated-cases`, // GET
            info:                           (data = {}) => `api/farm/${data.farm}/sanitary-protocol-model/${data.protocol}/pages/details`, // GET
            analysis:                       (data = {}) => `api/farm/${data.farm}/sanitary-protocol-model/${data.protocol}/pages/analysis`, // GET
          }
        },
        my_protocol:{
          datatable:                        (data = {}) => `api/farm/${data.farm}/sanitary-protocol/datatable`, // GET
          self:                             (data = {}) => `api/farm/${data.farm}/sanitary-protocol/${data.protocol}`, // GET, DELETE
          register_form:                    (data = {}) => `api/farm/${data.farm}/sanitary-protocol/form`, // GET
          applications:                     (data = {}) => `api/farm/${data.farm}/sanitary-protocol/${data.protocol}/pages/applications`, // GET
          behavior:                         (data = {}) => `api/farm/${data.farm}/sanitary-protocol/${data.protocol}/pages/behavior-analysis`, // GET
          cancel_form:                      (data = {}) => `api/farm/${data.farm}/sanitary-protocol/${data.protocol}/cancel/form`, // GET
          cancel:                           (data = {}) => `api/farm/${data.farm}/sanitary-protocol/${data.protocol}/cancel`, // DELETE
          update_form:                      (data = {}) => `api/farm/${data.farm}/sanitary-protocol/${data.protocol}/form`, // GET
          remove_form:                      (data = {}) => `api/farm/${data.farm}/sanitary-protocol/${data.protocol}/remove/form`, // GET
        }
      },
      withdrawal: {
        milk:                               (data = {}) => `api/farm/${data.farm}/milk-production/milk-discard/datatable`, // GET,
        meat:                               (data = {}) => `api/farm/${data.farm}/event/datatable/health/meat-withdrawal`, // GET
      }
    },
    apt_after_delivery:{
      update_form:                          (data = {}) => `/api/farm/${data.farm}/event/reproduction/apt-after-delivery/${data.event}/form` //GET
    },

    heat: {
      heat_events_datatable:                (data = {}) => `api/farm/${data.farm}/event/datatable/reproduction/heat`, // GET
      confirmed:                            (data = {}) => `api/farm/${data.farm}/event/datatable/reproduction/heat/confirmed`, // GET
      heat_event_details:                   (data = {}) => `api/farm/${data.farm}/event/datatable/reproduction/heat/${data.event}`, // GET
      confirm:                              (data = {}) => `api/farm/${data.farm}/event/reproduction/${data.event}/confirm-heat`, // POST
      unconfirm:                            (data = {}) => `api/farm/${data.farm}/event/reproduction/${data.event}/unconfirm-heat`, // POST
      form:                                 (data = {}) => `api/farm/${data.farm}/event/reproduction/confirm-heat/${data.event}/form`, // GET
    },

    visual_heat:{
      form:                                 (data = {}) => `api/farm/${data.farm}/event/reproduction/visual-heat/form`, // GET
      form_without_animal:                  (data = {}) => `api/farm/${data.farm}/animal/reproduction/visual-heat/form`, // GET
      update_form:                          (data = {}) => `api/farm/${data.farm}/event/reproduction/visual-heat/${data.event}/form`, // GET
    },

    pregnancy: {
      datatable:                            (data = {}) => `api/farm/${data.farm}/event/datatable/reproduction/pregnancy-diagnostic`, // GET
      form:                                 (data = {}) => `api/farm/${data.farm}/event/reproduction/pregnancy-diagnostic/animal/${data.animal}/form`, // GET
      update_form:                          (data = {}) => `api/farm/${data.farm}/event/reproduction/pregnancy-diagnostic/${data.event}/form`, // GET
      form_without_animal:                  (data = {}) => `api/farm/${data.farm}/animal/reproduction/pregnancy-diagnostic/form`, // GET
      second:{
        datatable:                          (data = {}) => `api/farm/${data.farm}/event/datatable/reproduction/pregnancy-second-confirmation`, // GET
      },
      third:{
        datatable:                          (data = {}) => `api/farm/${data.farm}/event/datatable/reproduction/pregnancy-third-confirmation`, // GET
      },
      many:{
        first:                              (data = {}) => `api/farm/${data.farm}/event/reproduction/many/pregnancy/form`, // GET
      },
      suspected:{
        datatable:                          (data = {}) => `api/farm/${data.farm}/event/datatable/reproduction/suspected-pregnancy-losses`, // GET
      },
    },

    reproductive_evaluation:{
      datatable:                            (data = {}) => `api/farm/${data.farm}/reproductive-evaluation/datatable`, // GET
      register_form:                        (data = {}) => `api/farm/${data.farm}/event/reproduction/evaluation/form`, // GET
      register:                             (data = {}) => `api/farm/${data.farm}/animal/${data.animal}/event/reproduction/evaluation`, // POST
      update_form:                          (data = {}) => `api/farm/${data.farm}/event/reproduction/evaluation/${data.event}/form`, // GET
      update:                               (data = {}) => `api/farm/${data.farm}/animal/${data.animal}/event/reproduction/evaluation/${data.event}`, // PUT
      register_many_form:                   (data = {}) => `api/farm/${data.farm}/event/reproduction/evaluation/many/form`, // GET
      register_many:                        (data = {}) => `api/farm/${data.farm}/event/reproduction/evaluation/many` // POST
    },

    drying: {
      drying_datatable:                     (data = {}) => `api/farm/${data.farm}/event/datatable/reproduction/dry`, // GET
      projection:                           (data = {}) => `api/farm/${data.farm}/pages/drying/projections`, // GET
      performed: {
        datatable:                          (data = {}) => `api/farm/${data.farm}/event/datatable/reproduction/performed-dryings`, // GET
      }
    },

    calving: {
      form:                                 (data = {}) => `api/farm/${data.farm}/event/reproduction/birth/form`, // GET
      datatable:                            (data = {}) => `api/farm/${data.farm}/event/datatable/reproduction/calving`, // GET
      pre_calving_datatable:                (data = {}) => `api/farm/${data.farm}/event/datatable/reproduction/pre-calving`, // GET
      update_form:                          (data = {}) => `api/farm/${data.farm}/event/reproduction/birth/${data.event}/form`, // GET
      iep:                                  (data = {}) => `api/farm/${data.farm}/pages/reproduction/average-delivery`, // GET
      first_calving:                        (data = {}) => `api/farm/${data.farm}/pages/reproduction/age-at-first-calving`, // GET
      graph: {
        calving_prediction:                 (data = {}) => `api/farm/${data.farm}/pages/reproduction/calving-projections`, // GET
      },
      performed: {
        datatable:                          (data = {}) => `api/farm/${data.farm}/calving/datatable`, // GET
      }
    },

    pre_calving: {
      form:                                 (data = {}) => `api/farm/${data.farm}/event/reproduction/pre-delivery/form`, // GET
      update_form:                          (data = {}) => `api/farm/${data.farm}/event/reproduction/pre-delivery/${data.event}/form`, // GET
    },

    abortion: {
      form:                                 (data = {}) => `api/farm/${data.farm}/event/reproduction/abortion/form`, // GET
      form_without_animal:                  (data = {}) => `api/farm/${data.farm}/animal/reproduction/abortion/form`, // GET
      update_form:                          (data = {}) => `api/farm/${data.farm}/event/reproduction/abortion/${data.event}/form`, // GET
    },

    dry: {
      form:                                 (data = {}) => `api/farm/${data.farm}/event/reproduction/dry/form`, // GET
      form_without_animal:                  (data = {}) => `api/farm/${data.farm}/animal/reproduction/dry/form`, // GET
      update_form:                          (data = {}) => `api/farm/${data.farm}/event/reproduction/dry/${data.event}/form`, // GET
    },

    induced_lactation: {
      form:                                 (data = {}) => `api/farm/${data.farm}/event/reproduction/induced-lactation/form`, // GET
      update_form:                          (data = {}) => `api/farm/${data.farm}/event/reproduction/induced-lactation/${data.event}/form`, // GET
    },

    embryo_transfer: {
      form:                                 (data = {}) => `api/farm/${data.farm}/event/reproduction/embryo-transfer/form`, // GET
      update_form:                          (data = {}) => `api/farm/${data.farm}/event/reproduction/embryo-transfer/${data.event}/form`, // GET
    },

    weaning: {
      form:                                 (data = {}) => `api/farm/${data.farm}/event/reproduction/weaning/form`, // GET
      form_without_animal:                  (data = {}) => `api/farm/${data.farm}/animal/reproduction/weaning/form`, // GET
      many_form:                            (data = {}) => `api/farm/${data.farm}/event/reproduction/many/weaning/form`, // GET
      update_form:                          (data = {}) => `api/farm/${data.farm}/event/reproduction/weaning/${data.event}/form`, // GET
    },

    insemination: {
      form:                                 (data = {}) => `api/farm/${data.farm}/event/reproduction/insemination/form`, // GET
      update_form:                          (data = {}) => `api/farm/${data.farm}/event/reproduction/insemination/${data.event}/form`, // GET
    },

    natural_breeding: {
      form:                                 (data = {}) => `api/farm/${data.farm}/event/reproduction/natural-breeding/form`, // GET
      update_form:                          (data = {}) => `api/farm/${data.farm}/event/reproduction/natural-breeding/${data.event}/form`, // GET
    },

    handling: {
      register:                             (data = {}) => `api/farm/${data.farm}/event/handling`, // POST
      register_form:                        (data = {}) => `api/farm/${data.farm}/event/handling/form`, // GET
      list_datatable:                       (data = {}) => `api/farm/${data.farm}/event/datatable/handling`, // GET
      update_form:                          (data = {}) => `api/farm/${data.farm}/event/handling/${data.handling}/form`, // GET
      update:                               (data = {}) => `api/farm/${data.farm}/event/handling/${data.handling}`, // PUT
      remove:                               (data = {}) => `api/farm/${data.farm}/event/handling/${data.handling}`, // DELETE
    },

    protocol: {
      self:                                 (data = {}) => `api/farm/${data.farm}/protocol-schedule/${data.protocol}`, // GET
      register_form:                        (data = {}) => `api/farm/${data.farm}/protocol-schedule/form`, // GET
      register:                             (data = {}) => `api/farm/${data.farm}/protocol-schedule`, // POST
      update_form:                          (data = {}) => `api/farm/${data.farm}/protocol-schedule/${data.protocol}/form`, // GET
      update:                               (data = {}) => `api/farm/${data.farm}/protocol-schedule/${data.protocol}`, // PUT
      remove:                               (data = {}) => `api/farm/${data.farm}/protocol-schedule/${data.protocol}`, // DELETE
      list_datatable:                       (data = {}) => `api/farm/${data.farm}/protocol-schedule/datatable`, // GET
      animal_datatable:                     (data = {}) => `api/farm/${data.farm}/protocol-schedule/${data.protocol}/datatable`, // GET
      add_animal:                           (data = {}) => `api/farm/${data.farm}/protocol-schedule/${data.protocol}/animals/add`, // PUT
      add_animal_form:                      (data = {}) => `api/farm/${data.farm}/protocol-schedule/${data.protocol}/animals/add/form`, // GET
      add_animals:                          (data = {}) => `api/farm/${data.farm}/protocol-schedule/add-with-protocol-search/form`, // GET
      remove_multiple_animal_form:          (data = {}) => `api/farm/${data.farm}/protocol-schedule/${data.protocol}/animals/remove/form`, // GET
      remove_multiple_animal:               (data = {}) => `api/farm/${data.farm}/protocol-schedule/${data.protocol}/animals/remove`, // DELETE
      restore_animal:                       (data = {}) => `api/farm/${data.farm}/protocol-schedule/${data.protocol}/animal/${data.animal}`, // PATCH
      register_reproduction_form:           (data = {}) => `api/farm/${data.farm}/protocol-schedule/${data.protocol}/animals/reproductive-method/form/quick`, // GET
      register_reproduction_et_form:        (data = {}) => `api/farm/${data.farm}/protocol-schedule/${data.protocol}/animals/reproductive-method/form/quick-et`, // GET
      register_ai:                          (data = {}) => `api/farm/${data.farm}/protocol-schedule/${data.protocol}/animals/artificial-insemination`, // POST
      register_ai_form:                     (data = {}) => `api/farm/${data.farm}/protocol-schedule/${data.protocol}/animals/artificial-insemination/form`, // GET
      register_et:                          (data = {}) => `api/farm/${data.farm}/protocol-schedule/${data.protocol}/animals/embryo-transfer`, // POST
      register_et_form:                     (data = {}) => `api/farm/${data.farm}/protocol-schedule/${data.protocol}/animals/embryo-transfer/form`, // GET
      results_analysis:                     (data = {}) => `api/farm/${data.farm}/protocol-schedule/${data.protocol}/pages/results-analysis`, // GET
      datagrid_animals_removed:             (data = {}) => `api/farm/${data.farm}/protocol-schedule/${data.protocol}/datatable-removed`, // GET
      schedule:                             (data = {}) => `api/farm/${data.farm}/protocol-schedule/${data.protocol}/handling`, //GET
      search:                               (data = {}) => `api/farm/${data.farm}/protocol-schedule/search`, // GET
      protocol_model_datatable:             (data = {}) => `api/farm/${data.farm}/protocol-model/datatable`, // GET
      protocol_model_register_form:         (data = {}) => `api/farm/${data.farm}/protocol-model/form`, // GET
      protocol_model_register:              (data = {}) => `api/farm/${data.farm}/protocol-model`, // POST
      protocol_model_update_form:           (data = {}) => `api/farm/${data.farm}/protocol-model/${data.protocol}/form`, // GET
      protocol_model_update:                (data = {}) => `api/farm/${data.farm}/protocol-model/${data.protocol}`, // PUT
      protocol_model_delete:                (data = {}) => `api/farm/${data.farm}/protocol-model/${data.protocol}`, // DELETE
      protocol_model_restore:               (data = {}) => `api/farm/${data.farm}/protocol-model/${data.protocol}`, // PATCH
      protocol_model_duplicate:             (data = {}) => `api/farm/${data.farm}/protocol-model/${data.protocol}/duplicate/form` //GET
    },

    event: {
      restore:                              (data = {}) => `api/farm/${data.farm}/event/${data.event}/restore`, // POST
      reproduction: {
        many_events:                        (data = {}) => `api/farm/${data.farm}/event/reproduction/many`, // POST
        many_ai_form:                       (data = {}) => `api/farm/${data.farm}/event/reproduction/many/insemination/form`, // GET
        many_et_form:                       (data = {}) => `api/farm/${data.farm}/event/reproduction/many/embryo-transfer/form`, // GET
        many_nm_form:                       (data = {}) => `api/farm/${data.farm}/event/reproduction/many/natural-breeding/form`, // GET
        many_delivery_form:                 (data = {}) => `api/farm/${data.farm}/event/reproduction/many/delivery/form`, // GET
        many_induced_lactation_form:        (data = {}) => `api/farm/${data.farm}/event/reproduction/many/induced-lactation/form`, // GET
        many_induced_lactation:             (data = {}) => `api/farm/${data.farm}/event/reproduction/many/induced-lactation`, // POST
        empty_update_form:                  (data = {}) => `api/farm/${data.farm}/event/reproduction/empty/${data.event}/form`, // GET
        heifer_register_form:               (data = {}) => `api/farm/${data.farm}/event/reproduction/heifer/form`, // GET
        heifer_update_form:                 (data = {}) => `api/farm/${data.farm}/event/reproduction/heifer/${data.event}/form`, // GET
        executed_weaning_datatable:         (data = {}) => `api/farm/${data.farm}/event/datatable/reproduction/performed-weanings`, // GET
        conception_rate: {
          inseminators:                     (data = {}) => `api/farm/${data.farm}/event/reproduction/inseminators-conception-rate`, // GET
          semens:                           (data = {}) => `api/farm/${data.farm}/event/reproduction/semens-conception-rate`, // GET
        },
      }
    },

    new_semen: { 
      datatable:                            (data = {}) => `api/farm/${data.farm}/new-semen/datatable`, // GET
      register_form:                        (data = {}) => `api/farm/${data.farm}/new-semen/form`, // GET
      update_form:                          (data = {}) => `api/farm/${data.farm}/new-semen/${data.semen}/form`, // GET
      archive:                              (data = {}) => `api/farm/${data.farm}/new-semen/${data.semen}/archive`, // PATCH
      unarchive_form:                       (data = {}) => `api/farm/${data.farm}/new-semen/${data.semen}/unarchive/form`, // GET
      remove_form:                          (data = {}) => `api/farm/${data.farm}/new-semen/${data.semen}/delete/form`, // GET
    },

    semen: {
      register_form:                        (data = {}) => `api/farm/${data.farm}/semen/form`, // GET
      datatable:                            (data = {}) => `api/farm/${data.farm}/semen/datatable`, // GET
      register:                             (data = {}) => `api/farm/${data.farm}/semen`, // POST
      update_form:                          (data = {}) => `api/farm/${data.farm}/semen/${data.semen}/form`, // GET
      update:                               (data = {}) => `api/farm/${data.farm}/semen/${data.semen}`, // PUT
      remove:                               (data = {}) => `api/farm/${data.farm}/semen/${data.semen}`, // DELETE
      replace_form:                         (data = {}) => `api/farm/${data.farm}/semen/replace/form`, // GET
      replace:                              (data = {}) => `api/farm/${data.farm}/semen/replace`, // PUT
      link_to_animal: {
        register_form:                      (data = {}) => `api/farm/${data.farm}/semen/link-to-animal/form`, // GET
        update_form:                        (data = {}) => `api/farm/${data.farm}/semen/${data.semen}/link-to-animal/form`, // GET
        update:                             (data = {}) => `api/farm/${data.farm}/semen/${data.semen}/link-to-animal`, // PUT
      },
      self:                                 (data = {}) => `api/farm/${data.farm}/semen/${data.semen}`, // GET
      services:{
        datagrid:                           (data = {}) => `api/farm/${data.farm}/semen/${data.semen}/services/datagrid`, // GET
      },
    },
    embryo_donor:{
      datagrid:                             (data = {}) => `api/farm/${data.farm}/embryo-donor/datagrid`, // GET
      register_form:                        (data = {}) => `api/farm/${data.farm}/embryo-donor/form`, //GET
      register:                             (data = {}) => `api/farm/${data.farm}/embryo-donor`, //POST
      update_form:                          (data = {}) => `api/farm/${data.farm}/embryo-donor/${data.donor}/form`, //GET
      update:                               (data = {}) => `api/farm/${data.farm}/embryo-donor/${data.donor}`, //PUT
      delete:                               (data = {}) => `api/farm/${data.farm}/embryo-donor/${data.donor}`, //DELETE
      restore:                              (data = {}) => `api/farm/${data.farm}/embryo-donor/${data.donor}`, //PATCH
      replace_form:                         (data = {}) => `api/farm/${data.farm}/embryo-donor/replace/form`, //GET
      replace:                              (data = {}) => `api/farm/${data.farm}/embryo-donor/replace`, //PUT
    },
    inseminator: {
      restore:                              (data = {}) => `api/farm/${data.farm}/inseminator/${data.inseminator}`, // PATCH
      datatable:                            (data = {}) => `api/farm/${data.farm}/inseminator/datatable`, // GET
      register_form:                        (data = {}) => `api/farm/${data.farm}/inseminator/form`, // GET
      update_form:                          (data = {}) => `api/farm/${data.farm}/inseminator/${data.inseminator}/form`, // GET
      register:                             (data = {}) => `api/farm/${data.farm}/inseminator`, // POST
      self:                                 (data = {}) => `api/farm/${data.farm}/inseminator/${data.inseminator}`, // PUT, DELETE
    },

    mating: {
      form:                                 (data = {}) => `api/farm/${data.farm}/mating/form`, // GET
      datagrid:                             (data = {}) => `api/farm/${data.farm}/mating/datagrid`, // GET
      register:                             (data = {}) => `api/farm/${data.farm}/mating`, // POST
      update_form:                          (data = {}) => `api/farm/${data.farm}/mating/${data.mating}/form`, //GET
      update_register:                      (data = {}) => `api/farm/${data.farm}/mating/${data.mating}`, //PUT
      delete:                               (data = {}) => `api/farm/${data.farm}/mating/${data.mating}`, //DELETE
    },
    matrix: {
      datagrid:                             (data = {}) => `api/farm/${data.farm}/matrix/datagrid`, // GET
      children_datagrid:                    (data = {}) => `api/farm/${data.farm}/matrix/${data.matrix}/children/datagrid`, // GET
      register_form:                        (data = {}) => `api/farm/${data.farm}/matrix/form`, // GET
      register:                             (data = {}) => `api/farm/${data.farm}/matrix`, // POST
      update_form:                          (data = {}) => `api/farm/${data.farm}/matrix/${data.matrix}/form`, // GET
      update:                               (data = {}) => `api/farm/${data.farm}/matrix/${data.matrix}`, // PUT
      delete_form:                          (data = {}) => `api/farm/${data.farm}/matrix/${data.matrix}/delete/form`, // GET
      delete:                               (data = {}) => `api/farm/${data.farm}/matrix/${data.matrix}/delete`, // DELETE
      replace_form:                         (data = {}) => `api/farm/${data.farm}/matrix/replace/form`, // GET
      replace:                              (data = {}) => `api/farm/${data.farm}/matrix/replace`, // PUT
    },

    tasks: {
      complete:                             (data = {}) => `api/farm/${data.farm}/task/${data.task}/complete`, // PUT
      reject:                               (data = {}) => `api/farm/${data.farm}/task/${data.task}/reject`, // PUT
      reschedule:                           (data = {}) => `api/farm/${data.farm}/task/${data.task}/reschedule`, // PUT
      bulk: {
        complete:                           (data = {}) => `api/farm/${data.farm}/task/complete-many`, // PUT
        reject:                             (data = {}) => `api/farm/${data.farm}/task/reject-many`, // PUT
      },
    },

    c_com:{
      self:                                 (data = {}) => `api/farm/${data.farm}/c-com/${data.ccom}`, // GET
      datatable:                            (data = {}) => `api/farm/${data.farm}/c-com/datatable-with-batches`, // GET
      batch_attach_form:                    (data = {}) => `api/farm/${data.farm}/c-com/${data.ccom}/batch/form`, // GET
      batch_attach:                         (data = {}) => `api/farm/${data.farm}/c-com/${data.ccom}/batch`, // PUT
      alert_with_instructions:              (data = {}) => `api/farm/${data.farm}/c-com/pages/farm-monitoring-ccom-alert`, // GET
      alert:                                (data = {}) => `api/farm/${data.farm}/collar/summary/datatable/alert`, // GET
    },

    cow_comfort:{
      map:                                  (data = {}) => `api/farm/${data.farm}/c-env/map`, // GET
      thi_resource:                         (data = {}) => `api/farm/${data.farm}/thi-resource/${data.point}`, // GET
      datatable:                            (data = {}) => `api/farm/${data.farm}/c-env/datatable`, // GET
      attach_form:                          (data = {}) => `api/farm/${data.farm}/c-env/device-point/form`, // GET
      attach:                               (data = {}) => `api/farm/${data.farm}/c-env/device-point`, // POST
      change_form:                          (data = {}) => `api/farm/${data.farm}/c-env/device-point/change/form`, // GET
      change:                               (data = {}) => `api/farm/${data.farm}/c-env/device-point/change`, // PUT
      detach_form:                          (data = {}) => `api/farm/${data.farm}/c-env/device-point/detach/${data.point}/form`, // GET
      detach:                               (data = {}) => `api/farm/${data.farm}/c-env/device-point/detach/${data.point}`, // DELETE
      history:                              (data = {}) => `api/farm/${data.farm}/c-env/${data.c_env}/device-point/history/datatable`, // GET
      point:{
        datatable:                          (data = {}) => `api/farm/${data.farm}/device-point/datatable`, // GET
        register:                           (data = {}) => `api/farm/${data.farm}/device-point`, // POST
        register_form:                      (data = {}) => `api/farm/${data.farm}/device-point/form`, // GET
        update_form:                        (data = {}) => `api/farm/${data.farm}/device-point/${data.point}/form`, // GET
        update:                             (data = {}) => `api/farm/${data.farm}/device-point/${data.point}`, // PUT, PATCH
        delete:                             (data = {}) => `api/farm/${data.farm}/device-point/${data.point}`, // DELETE
        drawer:                             (data = {}) => `api/farm/${data.farm}/device-point/${data.point}/pages/drawer`, // GET
      },
      thi:{
        datatable:                          (data = {}) => `api/farm/${data.farm}/device-point/data/datatable`, // GET
      }
    },
  },

  database: {
    semen: {
      datatable:                            (data = {}) => `api/semen/datatable`, // GET
      register_form:                        (data = {}) => `api/semen/form`, // GET
      register:                             (data = {}) => `api/semen`, // POST
      update_form:                          (data = {}) => `api/semen/${data.semen}/form`, // GET
      update:                               (data = {}) => `api/semen/${data.semen}`, // PUT
      remove:                               (data = {}) => `api/semen/${data.semen}`, // DELETE
      replace_form:                         (data = {}) => `api/semen/replace/form`, // GET
      replace:                              (data = {}) => `api/semen/replace`, // PUT
    },
    new_semen: {
      datatable:                            (data = {}) => `api/new-semen/datatable`, // GET
      register_form:                        (data = {}) => `api/new-semen/form`, // GET
      register:                             (data = {}) => `api/new-semen`, // POST
      update_form:                          (data = {}) => `api/new-semen/${data.semen}/form`, // GET
      update:                               (data = {}) => `api/new-semen/${data.semen}`, // PUT
      restore:                              (data = {}) => `api/new-semen/${data.semen}`, // PATCH
      remove:                               (data = {}) => `api/new-semen/${data.semen}`, // DELETE
    },
    semen_company: {
      datatable:                            (data = {}) => `api/semen-company/datatable`, // GET
      register_form:                        (data = {}) => `api/semen-company/form`, // GET
      register:                             (data = {}) => `api/semen-company`, // POST
      update_form:                          (data = {}) => `api/semen-company/${data.semen_company}/form`, // GET
      update:                               (data = {}) => `api/semen-company/${data.semen_company}`, // PUT
      remove:                               (data = {}) => `api/semen-company/${data.semen_company}`, // DELETE
    },
    treatment: {
      datatable:                            (data = {}) => `api/treatment/datatable`, // GET
      self:                                 (data = {}) => `api/treatment/${data.id}`, // PUT, DELETE
      register_form:                        (data = {}) => `api/treatment/form`, // GET
      register:                             (data = {}) => `api/treatment`, // POST
      update_form:                          (data = {}) => `api/treatment/${data.id}/form`, // GET
    },
    manufacturer:{
      datatable:                            (data = {}) => `api/treatment/manufacturer/datatable`, // GET
      self:                                 (data = {}) => `api/treatment/manufacturer/${data.id}`, // PUT, DELETE
      register_form:                        (data = {}) => `api/treatment/manufacturer/form`, // GET
      register:                             (data = {}) => `api/treatment/manufacturer`, // POST
      update_form:                          (data = {}) => `api/treatment/manufacturer/${data.id}/form`, // GET
    },
    help_pages:{
      datatable:                            (data = {}) => `api/help/datatable`, // GET
      register_form:                        (data = {}) => `api/help/form`, // GET
      register:                             (data = {}) => `api/help`, // POST
      update_form:                          (data = {}) => `api/help/${data.help}/form`, // GET
      self:                                 (data = {}) => `api/help/${data.help}`, // DELETE, PUT
      list:                                 (data = {}) => `api/help`, // GET
      help:                                 (data = {}) => `api/help/help-route/${data.help}`, // GET
    }
  },

  dataview: {
    contracts:{
      lead_time:                            (data = {}) => `api/data-view/contracts/lead-time`, // GET
      active:                               (data = {}) => `api/data-view/contracts/active-contracts`, // GET
      upsell_churn:                         (data = {}) => `api/data-view/contracts/upsell-churn`, // GET
      signed:                               (data = {}) => `api/data-view/contracts/accounts-contracts`, // GET
      opportunities:                        (data = {}) => `api/farm/opportunities`, // GET
    },
    benchmarking:{
      calving_interval:                     (data = {}) => `api/benchmark/calving-interval`, // GET
      conception_rate:                      (data = {}) => `api/benchmark/conception-rate`, // GET
      dim:                                  (data = {}) => `api/benchmark/dim`, // GET
      discard_rate:                         (data = {}) => `api/benchmark/discard-rate`, // GET
      pregnancy_rate:                       (data = {}) => `api/benchmark/pregnancy-rate`, // GET
      service_rate:                         (data = {}) => `api/benchmark/service-rate`, // GET
    },
    c_tech: {
      replacement:                          (data = {}) => `api/farm/${data.farm}/collar/replacement/datatable`, // GET
      technical_revision:                   (data = {}) => `api/farm/${data.farm}/collar/technical-revision/datatable`, // GET
    },
    c_com:{
      farm_ccom_count:                      (data = {}) => `api/farm/${data.farm}/ccom/count`, // GET
    }
  },

  cow_comfort:{
    datatable:                              (data = {}) => `api/cenv/datatable`, // GET
    self:                                   (data = {}) => `api/cenv/${data.c_env}`, // GET
    revision:                               (data = {}) => `api/cenv/${data.c_env}/revision`, // PUT
    discard:                                (data = {}) => `api/cenv/${data.c_env}/discard`, // PUT
    history:                                (data = {}) => `api/cenv/${data.c_env}/history`, // GET
    status:                                 (data = {}) => `api/cenv/${data.c_env}/status/datatable`, // GET
  },

  collar: {
    inventory_datatable:                    (data = {}) => `api/collar/datatable`, // GET
    inventory_status_datatable:             (data = {}) => `api/collar/status/datatable`, // GET
    summary_status:                         (data = {}) => `api/collar/status/summary/datatable`, // GET
    self:                                   (data = {}) => `api/collar/${data.collar}`, // GET
    map:                                    (data = {}) => `api/collar/${data.collar}/history`, // GET
    status_datatable:                       (data = {}) => `api/collar/${data.collar}/status/datatable`, // GET
    animal_history_datatable:               (data = {}) => `api/collar/${data.collar}/animal/history/datatable`, // GET
    farm_history_datatable:                 (data = {}) => `api/collar/${data.collar}/farm/history/datatable`, // GET
    discard:                                (data = {}) => `api/collar/${data.collar}/discard`, // PUT
    revision:                               (data = {}) => `api/collar/${data.collar}/revision`, // PUT
    break:                                  (data = {}) => `api/collar/replacement/datatable`, // GET
    tags: {
      bulk: {
        register_form:                      (data = {}) => `api/collar/tag/bulk/add/form`, // GET,
        register:                           (data = {}) => `api/collar/tag/bulk/add`, // PUT,
        remove:                             (data = {}) => `api/collar/tag/bulk/remove`, // DELETE,
      },
      single: {
        register_form:                      (data = {}) => `api/collar/${data.collar}/tag/add/form`, // GET,
        register:                           (data = {}) => `api/collar/${data.collar}/tag/add`, // PUT,
        remove:                             (data = {}) => `api/collar/${data.collar}/tag/remove`, // PUT,
      }
    },
    break_version_detail:                   (data = {}) => `api/collar/version/${data.version}/manufacture-shipment/${data.manufacture}`, // GET

    event: {
      datatable:                            (data = {}) => `api/collar/${data.collar}/event/datatable`, // GET
      normalization:                        (data = {}) => `api/collar/${data.collar}/event/normalization`, // GET
      normalization_form:                   (data = {}) => `api/collar/${data.collar}/event/create/normalization`, // GET
      replacement_request_form:             (data = {}) => `api/collar/${data.collar}/event/create/replacement-request`, // GET
      replacement_request:                  (data = {}) => `api/collar/${data.collar}/event/replacement-request`, // POST
    },
  },

  ccom: {
    inventory_datatable:                    (data = {}) => `api/ccom/datatable`, // GET
    store_many:                             (data = {}) => `api/ccom/store-many`, // POST
    attach_form:                            (data = {}) => `api/ccom/attach/form`, // GET
    summary_ccom:                           (data = {}) => `api/farm/ccom/summary/datatable`, // GET
    disconnected:                           (data = {}) => `api/farm/ccom/disconnected/datatable`, // GET
    reconnected:                            (data = {}) => `api/farm/ccom/reconnected/datatable`, // GET
    self:                                   (data = {}) => `api/ccom/${data.ccom}`, // GET
    replace:                                (data = {}) => `api/ccom/${data.ccom}/replace`, // PUT
    replace_form:                           (data = {}) => `api/ccom/${data.ccom}/replace/form`, // GET
    status_map:                             (data = {}) => `api/ccom/${data.ccom}/status/map`, // GET
    map:                                    (data = {}) => `api/farm/${data.farm}/ccom/map`, // GET
    status_datatable:                       (data = {}) => `api/ccom/${data.ccom}/status/datatable`, // GET
    primary_status_datatable:               (data = {}) => `api/ccom/${data.ccom}/primary/status/datatable`, // GET
    attachment_farm_history_datatable:      (data = {}) => `api/ccom/${data.ccom}/farm/history/datatable`, // GET
    interval:{
      farm:                                 (data = {}) => `api/ccom/data-delays/by-farm/datatable`, // GET
      batch:                                (data = {}) => `api/ccom/data-delays/by-batch/datatable`, // GET
    },
    farm: {
      attach:                               (data = {}) => `api/ccom/${data.ccom}/farm/${data.farm}/attach`, // PUT
      detach:                               (data = {}) => `api/ccom/${data.ccom}/farm/${data.farm}/detach`, // PUT
      connectivity:                         (data = {}) => `api/farm/${data.farm}/ccom/connectivity`, // GET
      datatable:                            (data = {}) => `api/farm/${data.farm}/ccom/datatable`, // GET
      history_ccom:                         (data = {}) => `api/farm/${data.farm}/ccom/history`, // GET
      alert_history:                        (data = {}) => `api/farm/${data.farm}/ccom/alert-history`, // GET
      data_interval:                        (data = {}) => `api/farm/${data.farm}/collar/animal-batch-delay/datatable`, // GET
    },
    config: {
      register:                             (data = {}) => `api/ccom/${data.ccom}/configuration`, // PUT
      form:                                 (data = {}) => `api/ccom/${data.ccom}/configuration/form`, // GET
      hexkey_register:                      (data = {}) => `api/ccom/${data.ccom}/configuration/hex-key`, // POST
      hexkey_form:                          (data = {}) => `api/ccom/${data.ccom}/configuration/hex-key/form`, // GET
      history_datatable:                    (data = {}) => `api/ccom/${data.ccom}/configuration/history/datatable`, // GET
    },
    maintenance: {
      self:                                 (data = {}) => `api/ccom/${data.ccom}/maintenance-history/${data.maintenance}`, // PUT, DELETE
      register:                             (data = {}) => `api/ccom/${data.ccom}/maintenance-history`, // POST
      form:                                 (data = {}) => `api/ccom/${data.ccom}/maintenance-history/form`, // GET
      update_form:                          (data = {}) => `api/ccom/${data.ccom}/maintenance-history/${data.maintenance}/form`, // GET
      history_datatable:                    (data = {}) => `api/ccom/${data.ccom}/maintenance-history/datatable`, // GET
    },
    support_notes:{
      register:                             (data = {}) => `api/farm/${data.farm}/tech-support-notes`, // POST
      form:                                 (data = {}) => `api/farm/${data.farm}/tech-support-notes/form`, // GET
      self:                                 (data = {}) => `api/farm/${data.farm}/tech-support-notes/${data.note}`, // PUT, DELETE
      form_update:                          (data = {}) => `api/farm/${data.farm}/tech-support-notes/${data.note}/form`, // GET
      datatable:                            (data = {}) => `api/farm/${data.farm}/tech-support-notes/datatable`, // GET
    }
  },

  company: {
    self:                                   (data = {}) => `api/company/${data.company}`, // GET
    list_datatable:                         (data = {}) => `api/company/datatable`, // GET
    register_form:                          (data = {}) => `api/company/form`, // GET
    register:                               (data = {}) => `api/company`, // POST
    update_form:                            (data = {}) => `api/company/${data.company}/form`, // GET
    update:                                 (data = {}) => `api/company/${data.company}`, // PUT
    remove:                                 (data = {}) => `api/company/${data.company}`, // DELETE
    projects:{
      datatable:                            (data = {}) => `api/company/${data.company}/project/datagrid`, // GET
      self:                                 (data = {}) => `api/company/${data.company}/project/${data.company_project}`, // GET
      contracts: {
        datatable:                          (data = {}) => `api/company/${data.company}/project/${data.company_project}/contract-event/datatable`, // GET
      },
      register_form:                        (data = {}) => `api/company/${data.company}/project/form`, // GET
      register:                             (data = {}) => `api/company/${data.company}/project`, // POST
      update_form:                          (data = {}) => `api/company/${data.company}/project/${data.company_project}/form`, // GET
      update:                               (data = {}) => `api/company/${data.company}/project/${data.company_project}`, // PUT
      activate:                             (data = {}) => `api/company/${data.company}/project/${data.company_project}/activate`, // PATCH
      deactivate:                           (data = {}) => `api/company/${data.company}/project/${data.company_project}/deactivate`, // PATCH
      delete:                               (data = {}) => `api/company/${data.company}/project/${data.company_project}`, // DELETE
    },
    customization:{
      form:                                 (data = {}) => `api/company/${data.company}/business-configuration/form`, // GET
      register:                             (data = {}) => `api/company/${data.company}/business-configuration`, // POST
    },
    portfolio:{
      datatable:                            (data = {}) => `api/company/${data.company}/portfolio/datagrid`, // GET
      register_form:                        (data = {}) => `api/company/${data.company}/portfolio/form`, // GET
      register:                             (data = {}) => `api/company/${data.company}/portfolio`, // GET
      update_form:                          (data = {}) => `api/company/${data.company}/portfolio/${data.portfolio}/form`, // GET
      update:                               (data = {}) => `api/company/${data.company}/portfolio/${data.portfolio}`, // PUT
      delete:                               (data = {}) => `api/company/${data.company}/portfolio/${data.portfolio}`, // DELETE
      transfer_left:                        (data = {}) => `api/company/${data.company}/portfolio/${data.portfolio}/farm/available`, //GET
      transfer_right:                       (data = {}) => `api/company/${data.company}/portfolio/${data.portfolio}/farm`, //GET
      transfer_save:                        (data = {}) => `api/company/${data.company}/portfolio/${data.portfolio}/farm`, //GET
    },
    role: {
      datatable:                            (data = {}) => `api/company/${data.company}/role/datatable`, // GET
      register:                             (data = {}) => `api/company/${data.company}/role`, // POST
      register_form:                        (data = {}) => `api/company/${data.company}/role/form`, // GET
      update_form:                          (data = {}) => `api/company/${data.company}/role/${data.role}/form`, // GET
      self:                                 (data = {}) => `api/company/${data.company}/role/${data.role}`, // PUT, DELETE
      permissions:                          (data = {}) => `api/company/${data.company}/role/${data.role}/permission`, // GET, POST, DELETE
      duplicate:                            (data = {}) => `api/company/${data.company}/role/duplicate`, // POST
    },
    user: {
      datatable:                            (data = {}) => `api/company/${data.company}/user/datatable`, // GET
      register:                             (data = {}) => `api/company/${data.company}/user`, // POST
      register_form:                        (data = {}) => `api/company/${data.company}/user/form`, // GET
      update:                               (data = {}) => `api/company/${data.company}/user/${data.user}`, // PUT
      update_form:                          (data = {}) => `api/company/${data.company}/user/${data.user}/form`, // GET
      remove:                               (data = {}) => `api/company/${data.company}/user/${data.user}`, // DELETE
    },
    job: {
      list:                                 (data = {}) => `api/company/${data.company}/job`, // GET
      datatable:                            (data = {}) => `api/job/datatable`, // GET
    },
    okr:{
      datatable:                            (data = {}) => `api/company/${data.company}/goal/datagrid`, // GET
      drawer:                               (data = {}) => `api/company/${data.company}/goal/${data.metric}/drawer`, // GET
      update_form:                          (data = {}) => `api/company/${data.company}/goal/${data.metric}/form`, // GET
      update:                               (data = {}) => `api/company/${data.company}/goal/${data.metric}`, // GET
    },
    extra_modules: {
      datatable:                            (data = {}) => `api/company/${data.company}/modules/form`, // GET
      update:                               (data = {}) => `api/company/${data.company}/modules/${data.module_slug}`, // PUT
    }
  },

  system: {
    job: {
      list:                                 (data = {}) => `api/job`, // GET
    },
    role: {
      datatable:                            (data = {}) => `api/role/datatable`, // GET
      self:                                 (data = {}) => `api/role/${data.role}`, // GET
      register:                             (data = {}) => `api/role`, // DELETE, PUT
      register_form:                        (data = {}) => `api/role/form`, // GET
      update_form:                          (data = {}) => `api/role/${data.role}/form`, // GET
      permissions:                          (data = {}) => `api/role/${data.role}/permission`, // GET, POST, DELETE
      duplicate:                            (data = {}) => `api/role/duplicate`, // POST
      duplicate_form:                       (data = {}) => `api/role/duplicate/form`, // GET
    },
    routes:{
      datatable:                            (data = {}) => `api/route/datagrid`, // GET
      transfer_list:{
        available:                          (data = {}) => `api/route/${data.route}/available-permissions`, // GET
        registered:                         (data = {}) => `api/route/${data.route}/permissions`, // GET
        register:                           (data = {}) => `api/route/${data.route}/permissions`, // POST
        remove:                             (data = {}) => `api/route/${data.route}/permissions`, // DELETE
      },
      roles_form:                           (data = {}) => `api/route/${data.route}/roles`, // GET
      roles:                                (data = {}) => `api/route/${data.route}/roles`, // POST
    },
    permissions: {
      datatable:                            (data = {}) => `api/permission/datatable`, // GET
      update_form:                          (data = {}) => `api/permission/${data.permission}/form`, // GET
      update:                               (data = {}) => `api/permission/${data.permission}`, // PUT
    },
    release_notes: {
      datatable:                            (data = {}) => `api/release-notes/datatable`, // GET
      register_form:                        (data = {}) => `api/release-notes/form`, // GET
      register:                             (data = {}) => `api/release-notes`, // POST
      update_form:                          (data = {}) => `api/release-notes/${data.id}/form`, // GET
      update:                               (data = {}) => `api/release-notes/${data.id}`, // PUT
      remove:                               (data = {}) => `api/release-notes/${data.id}`, // DELETE
      last:                                 (data = {}) => `api/release-notes/last-release-note`, // GET
      view:                                 (data = {}) => `api/release-notes/${data.note}/view`, // PUT
      read_later:                           (data = {}) => `api/release-notes/${data.note}/read-later`, // PUT
      viewed_last:                          (data = {}) => `api/user/viewed-last-release-note`, // GET
    },
    transactional_emails:{
      datatable:                            (data = {}) => `api/mail/transactional/datatable`, // GET
      update_form:                          (data = {}) => `api/mail/transactional/${data.type}/form`, // GET
      update:                               (data = {}) => `api/mail/transactional/${data.type}`, // PUT
    }
  },

  module: {
    datatable:                              (data = {}) => `api/module/datatable`, // GET
    permissions:                            (data = {}) => `api/module/${data.module}/permission`, // GET, POST, DELETE
  },

  permissions: {
    module:{
      available:                            (data = {}) => `api/module/${data.module}/available`, // GET
      assigned:                             (data = {}) => `api/module/${data.module}/permission`, // GET
    },
    role: {
      system:{
          available:                            (data = {}) => `api/role/${data.role}/available`, // GET
          assigned:                             (data = {}) => `api/role/${data.role}/permission`, // GET
      },
      farm:{
          available:                            (data = {}) => `api/farm/${data.farm}/role/${data.role}/available`, // GET
          assigned:                             (data = {}) => `api/farm/${data.farm}/role/${data.role}/permission`, // GET
      },
      company:{
          available:                            (data = {}) => `api/company/${data.company}/role/${data.role}/available`, // GET
          assigned:                             (data = {}) => `api/company/${data.company}/role/${data.role}/permission`, // GET
      }
    },
  }
}
